import './style.css'
import * as THREE from 'three'
import * as dat from 'lil-gui'
import {
    FontLoader
} from 'three/examples/jsm/loaders/FontLoader.js'
import {
    TextGeometry
} from 'three/examples/jsm/geometries/TextGeometry'
import gsap from 'gsap'
import {
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader.js'
//Post-processing
import {
    EffectComposer
} from 'three/examples/jsm/postprocessing/EffectComposer.js'
import {
    RenderPass
} from 'three/examples/jsm/postprocessing/RenderPass.js'
import {
    GlitchPass
} from 'three/examples/jsm/postprocessing/GlitchPass.js'
import {
    ShaderPass
} from 'three/examples/jsm/postprocessing/ShaderPass';
import {
    BloomPass
} from 'three/examples/jsm/postprocessing/BloomPass';
import {
    FilmPass
} from 'three/examples/jsm/postprocessing/FilmPass.js';
import {
    DotScreenPass
} from 'three/examples/jsm/postprocessing/DotScreenPass.js';
import {
    MaskPass,
    ClearMaskPass
} from 'three/examples/jsm/postprocessing/MaskPass.js';
import {
    TexturePass
} from 'three/examples/jsm/postprocessing/TexturePass.js';

import {
    BleachBypassShader
} from 'three/examples/jsm/shaders/BleachBypassShader.js';
import {
    ColorifyShader
} from 'three/examples/jsm/shaders/ColorifyShader.js';
import {
    HorizontalBlurShader
} from 'three/examples/jsm/shaders/HorizontalBlurShader.js';
import {
    VerticalBlurShader
} from 'three/examples/jsm/shaders/VerticalBlurShader.js';
import {
    SepiaShader
} from 'three/examples/jsm/shaders/SepiaShader.js';
import {
    VignetteShader
} from 'three/examples/jsm/shaders/VignetteShader.js';
import {
    GammaCorrectionShader
} from 'three/examples/jsm/shaders/GammaCorrectionShader.js';
import {
    UnrealBloomPass
} from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import {
    SAOPass
} from 'three/examples/jsm/postprocessing/SAOPass.js';
import {
    BokehPass
} from 'three/examples/jsm/postprocessing/BokehPass.js';
import {
    FXAAShader
} from 'three/examples/jsm/shaders/FXAAShader.js';
import {
    HalftonePass
} from 'three/examples/jsm/postprocessing/HalftonePass.js';
import "@lottiefiles/lottie-player";
import {
    TAARenderPass
} from 'three/examples/jsm/postprocessing/TAARenderPass.js';
import LocomotiveScroll from 'locomotive-scroll';
import Stats from 'three/examples/jsm/libs/stats.module'
import Bodymovin from 'bodymovin'


// Musique de fond
let audioFond = new Audio('/audio/Ryoji Ikeda - data.matrix.mp3')
let audioFondOk = true

//html
const sectionMain = document.getElementById("sectionMain")

// Cursor
const cursorDesign = document.querySelector('.cursor');

document.addEventListener('mousemove', e => {
    cursorDesign.setAttribute('style', 'top:' + (e.pageY - 20) + "px; left:" + (e.pageX - 20) + "px;")
})

document.addEventListener('click', () => {
    cursorDesign.classList.add('expand');

    setTimeout(() => {
        cursorDesign.classList.remove("expand");
    }, 500);
})

// MENU Burger
const burger = document.querySelector(".burger")
burger.addEventListener('click', () => {
    burger.classList.toggle('active')
})




setTimeout(() => {
    audioFond.volume = 0.5;
    audioFond.play()
    ch_zoom()

}, 0)

/**
 * Base
 */

// Canvas
const canvas = document.querySelector('canvas.webgl')
const bodyHTML = document.getElementById('canvas')


// Scene
const scene = new THREE.Scene()

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}


/**
 * Camera
 */
// Base camera
// Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
camera.position.y = 0
cameraGroup.add(camera)


/**
 * Overlay (loading page)
 */
const overlayGeometry = new THREE.PlaneGeometry(4000000, 4000000, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
        uAlpha: {
            value: 1
        }
    },
    // ...
    fragmentShader: `
    uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

let loadCamOk = false

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.physicallyCorrectLights = true
//renderer.setClearColor('blue', 0.2);
window.onload = function () {
    resizeCanvas()
}

window.onresize = function () {
    resizeCanvas()
}

function resizeCanvas() {
    renderer.width = window.innerWidth
    renderer.height = window.innerWidth
}


window.addEventListener('resize', () => {
    // Update sizes 
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Update effect Composer(renderer effect)
    effectComposer.setSize(sizes.width, sizes.height)
    effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


/**
 * ///////////////////////////////////  Post processing
 */


const effectComposer = new EffectComposer(renderer)
effectComposer.setSize(sizes.width, sizes.height)
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


const renderPass = new RenderPass(scene, camera)
effectComposer.addPass(renderPass)

// Test glitch
const glitchPass = new GlitchPass()
glitchPass.goWild = false
glitchPass.randX = 0.0001
effectComposer.addPass(glitchPass)

// Glitch Pass moin récurent
glitchPass.enabled = false
setInterval(() => {
    if (glitchPass.enabled === false && zoomSpaceInvader === null) {
        setTimeout(() => {
            //glitchPass.enabled = true
        }, 5000)
    } else if (glitchPass.enabled === true) {
        //glitchPass.enabled = false
    }

}, 10000)

// Test Lueur difuse

const bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 1.5, 0.4, 0.85);
bloomPass.threshold = 0.6
bloomPass.strength = 0.15; //0.6
bloomPass.radius = 1 //1


effectComposer.addPass(bloomPass)

// Test Sao Pass

let saoPass = new SAOPass(scene, camera, true, true);
saoPass.params.saoScale = 10
saoPass.params.saoBlur = true
saoPass.params.saoBlurRadius = 100
saoPass.params.saoBlurDepthCutoff = 1
//effectComposer.addPass(saoPass);

// Test amelioration pixel ratio

const pixelRatio = renderer.getPixelRatio();
const fxaaPass = new ShaderPass(FXAAShader);
fxaaPass.material.uniforms['resolution'].value.x = 1 / sizes.width * pixelRatio;
fxaaPass.material.uniforms['resolution'].value.y = 1 / sizes.height * pixelRatio;
//effectComposer.addPass(fxaaPass)


// Test filtre RGB

const paramsHalftone = {
    shape: 1,
    radius: 1,
    rotateR: Math.PI / 12,
    rotateB: Math.PI / 12 * 2,
    rotateG: Math.PI / 12 * 3,
    scatter: 0,
    blending: 1,
    blendingMode: 2,
    greyscale: false,
    disable: false
};
const halftonePass = new HalftonePass(window.innerWidth, window.innerHeight, paramsHalftone);
effectComposer.addPass(halftonePass)

// Amelioration couleur sombre du RGB

const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader)
effectComposer.addPass(gammaCorrectionPass)

let taaRenderPass = new TAARenderPass(scene, camera);
taaRenderPass.unbiased = true;
//effectComposer.addPass(taaRenderPass);

sectionMain.style.display = "none"

// LOADING BAR
const loadingBarElement = document.querySelector('.loading-bar')

//Lottie File
const playerLottie = document.querySelector("lottie-player");
playerLottie.style.display = "none"

playerLottie.addEventListener("rendered", (e) => {
    playerLottie.load(
        '{"v":"4.8.0","meta":{"g":"LottieFiles AE 1.0.0","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":279,"w":209,"h":207,"nm":"Space Rocket 2","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"Space Rocket Move","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[104,103,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[150,150,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":238,"op":305,"st":5,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Space Rocket Move","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[104,103,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[150,150,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":5,"op":145,"st":5,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"360 Rocket Move","refId":"comp_6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[104,103,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[150,150,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":145,"op":238,"st":5,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 10","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[-55,355,0],"to":[34.167,-34.167,0],"ti":[-34.167,34.167,0]},{"t":35,"s":[150,150,0]}],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,-16.667]},"t":0,"s":[300,300,100]},{"t":70,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":362,"st":-41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Space Rocket Move 2","parent":1,"refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":359,"st":0,"bm":0}]},{"id":"comp_2","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 10","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[-136,436,0],"to":[47.667,-47.667,0],"ti":[-47.667,47.667,0]},{"t":35,"s":[150,150,0]}],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.353,0.353,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,-16.667]},"t":0,"s":[300,300,100]},{"t":70,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":359,"st":-41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Rocket Loop 2","parent":1,"refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":385,"st":0,"bm":0}]},{"id":"comp_3","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 9","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":715,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Right Wing move","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[49.667,28.282,0],"to":[6.096,0,0],"ti":[-6.096,0,0]},{"t":48,"s":[86.243,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"s","pt":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[-2.053,0.065],[-0.362,1.329],[5.317,20.534],[0,0],[3.292,-12.714],[-0.898,-3.294],[-1.072,-0.034]],"o":[[0,0],[1.072,-0.034],[0.898,-3.294],[-3.292,-12.714],[0,0],[-5.317,20.534],[0.362,1.329],[2.053,0.066]],"v":[[-18.859,49.856],[-13.963,49.856],[-12.004,47.236],[-9.067,-2.546],[-18.859,-20.231],[-28.652,-2.546],[-25.714,47.236],[-23.756,49.856]],"c":true}]},{"t":48,"s":[{"i":[[0,0],[-2.677,0.067],[-0.473,1.368],[6.933,21.14],[0,0],[4.293,-13.089],[-1.171,-3.391],[-1.398,-0.035]],"o":[[0,0],[1.398,-0.035],[1.172,-3.391],[-4.293,-13.089],[0,0],[-6.933,21.14],[0.472,1.368],[2.677,0.067]],"v":[[-13.756,50.889],[-7.371,50.889],[-4.817,48.191],[-0.986,-3.058],[-13.756,-21.266],[-26.525,-3.058],[-22.694,48.191],[-20.141,50.889]],"c":true}]}],"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.268,38.004],[0.017,52.875],[2.094,37.765],[3.026,26.501]],"c":true}]},{"t":48,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":720,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":3,"nm":"Null 1","parent":1,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":636,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"Reverse Window Matte","parent":3,"td":1,"refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":385,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Reflection","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":26,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[24.908,124,0],"to":[40.667,0,0],"ti":[-40.667,0,0]},{"t":84,"s":[268.908,124,0]}],"ix":2},"a":{"a":0,"k":[94.5,19.5,0],"ix":1},"s":{"a":0,"k":[52.003,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[19,233],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[113.5,19.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[28,230],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.780391977348,0.827450980392,0.937255021638,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[80,18],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":665,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Rocket Matte 1","parent":3,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[52.592,48.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":713,"st":-12,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Rocket Window 1","parent":3,"tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[12.972,42.556,0],"to":[6.167,0,0],"ti":[-6.167,0,0]},{"t":48,"s":[49.972,42.556,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.505,-2.505],[2.505,-2.505],[2.505,2.505],[-2.505,2.505]],"o":[[2.505,2.505],[-2.505,2.505],[-2.505,-2.505],[2.505,-2.505]],"v":[[7.085,-10.791],[7.085,-1.715],[-1.99,-1.715],[-1.99,-10.791]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[4.218,4.218],[4.218,-4.218],[-4.218,-4.218],[-4.218,4.218]],"o":[[-4.218,-4.218],[-4.218,4.218],[4.218,4.218],[4.218,-4.218]],"v":[[10.19,-13.895],[-5.095,-13.895],[-5.095,1.39],[10.19,1.39]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":598,"st":-12,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"Window 2","parent":3,"refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":385,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":3,"nm":"Wings","parent":10,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":0,"k":[-1.5,-2.165,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"ip":0,"op":696,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Rocket","parent":3,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[52.592,48.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.247,-0.16],[0.698,-0.932],[-0.969,1.852],[0.183,1.67],[2.461,-1.287],[0.197,-2.368],[-0.18,-0.275],[0.375,-4.333]],"o":[[4.333,-0.375],[0.275,0.18],[2.368,-0.197],[1.287,-2.461],[-1.67,-0.183],[-1.852,0.969],[0.932,-0.698],[0.16,0.247],[0,0]],"v":[[-35.624,31.999],[-28.514,29.035],[-28.892,30.647],[-23.486,26.45],[-23.118,19.493],[-30.075,19.862],[-34.271,25.267],[-32.66,24.889],[-35.624,31.999]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.894117647059,0.74334489411,0.140253732719,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-23.141,19.469],"ix":2},"a":{"a":0,"k":[-23.141,19.469],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"t":0,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":21.332,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":42.664,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":63.998,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":84,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":106.67,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":128.002,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":149.336,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":170.668,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":192,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":213.332,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":234.664,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":255.998,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":277.33,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":298.67,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":320.002,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":341.336,"s":[100,100]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":362.668,"s":[119.916,123.04]},{"t":384,"s":[100,100]}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[11.809,-5.487],[0,0],[0,0]],"o":[[0,0],[5.487,-11.809],[0,0]],"v":[[8.502,-30.404],[26.699,-12.207],[29.643,-33.348]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.835294117647,0.835294117647,0.835294117647,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-23.622,11.579],[-26.401,12.506],[-16.211,22.695],[-15.285,19.916]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.725490196078,0.725490196078,0.725490196078,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":581,"st":2,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Left Wing move","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[49.667,28.282,0],"to":[-5.985,0,0],"ti":[5.985,0,0]},{"t":48,"s":[13.758,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[-266,266,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.205,38.004],[-0.03,52.875],[2.157,37.765],[3.026,26.501]],"c":true}]},{"t":48,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":695,"st":-12,"bm":0}]},{"id":"comp_4","layers":[{"ddd":0,"ind":2,"ty":3,"nm":"Rocket Window 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[51.504,130.199,0],"to":[16.403,0,0],"ti":[-16.403,0,0]},{"t":48,"s":[149.924,130.199,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[181,266,100]},{"t":48,"s":[266,266,100]}],"ix":6}},"ao":0,"ip":0,"op":711,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Rocket Matte 2","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":669,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Rocket Window 2","parent":2,"tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[2.547,-6.253,0],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":0,"k":[80,80,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.195,-3.195],[3.195,-3.195],[3.195,3.195],[-3.195,3.195]],"o":[[3.195,3.195],[-3.195,3.195],[-3.195,-3.195],[3.195,-3.195]],"v":[[8.337,-12.042],[8.337,-0.463],[-3.242,-0.463],[-3.242,-12.042]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.686274509804,0.933333333333,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3b","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":669,"st":-12,"bm":0}]},{"id":"comp_5","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Rocket Matte 3","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":669,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Rocket Window 1","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[51.504,130.199,0],"to":[16.403,0,0],"ti":[-16.403,0,0]},{"t":48,"s":[149.924,130.199,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[181,266,100]},{"t":48,"s":[266,266,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.505,-2.505],[2.505,-2.505],[2.505,2.505],[-2.505,2.505]],"o":[[2.505,2.505],[-2.505,2.505],[-2.505,-2.505],[2.505,-2.505]],"v":[[7.085,-10.791],[7.085,-1.715],[-1.99,-1.715],[-1.99,-10.791]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[4.218,4.218],[4.218,-4.218],[-4.218,-4.218],[-4.218,4.218]],"o":[[-4.218,-4.218],[-4.218,4.218],[4.218,4.218],[4.218,-4.218]],"v":[[10.19,-13.895],[-5.095,-13.895],[-5.095,1.39],[10.19,1.39]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":711,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Rocket Matte 2","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":669,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Rocket Window 2","parent":2,"tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[2.547,-6.253,0],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.195,-3.195],[3.195,-3.195],[3.195,3.195],[-3.195,3.195]],"o":[[3.195,3.195],[-3.195,3.195],[-3.195,-3.195],[3.195,-3.195]],"v":[[8.337,-12.042],[8.337,-0.463],[-3.242,-0.463],[-3.242,-12.042]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.686274509804,0.933333333333,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3b","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":669,"st":-12,"bm":0}]},{"id":"comp_6","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 10","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[-180,477,0],"to":[0,0,0],"ti":[0,0,0]},{"t":35,"s":[150,150,0]}],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,-16.667]},"t":0,"s":[300,300,100]},{"t":70,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":359,"st":-41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"360 Rocket","parent":1,"refId":"comp_7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":376,"st":0,"bm":0}]},{"id":"comp_7","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Rocket Fire","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[152.592,148.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.247,-0.16],[0.698,-0.932],[-0.969,1.852],[0.183,1.67],[2.461,-1.287],[0.197,-2.368],[-0.18,-0.275],[0.375,-4.333]],"o":[[4.333,-0.375],[0.275,0.18],[2.368,-0.197],[1.287,-2.461],[-1.67,-0.183],[-1.852,0.969],[0.932,-0.698],[0.16,0.247],[0,0]],"v":[[-35.624,31.999],[-28.514,29.035],[-28.892,30.647],[-23.486,26.45],[-23.118,19.493],[-30.075,19.862],[-34.271,25.267],[-32.66,24.889],[-35.624,31.999]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.800000059838,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-23.141,19.469],"ix":2},"a":{"a":0,"k":[-23.141,19.469],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"t":0,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":20.887,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":41.775,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":62.664,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":82.25,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":104.447,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":125.336,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":146.225,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":167.113,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":188,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":208.887,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":229.775,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":250.664,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":271.553,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":292.447,"s":[100,100]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":313.336,"s":[119.916,123.04]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":334.225,"s":[100,100]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":355.113,"s":[119.916,123.04]},{"t":376,"s":[100,100]}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rocket Fire","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":376,"st":2,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"360 Rocket Loop","refId":"comp_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":282,"op":376,"st":282,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"360 Rocket Loop","refId":"comp_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":188,"op":282,"st":188,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"360 Rocket Loop","refId":"comp_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":94,"op":188,"st":94,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"360 Rocket Loop","refId":"comp_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":94,"st":0,"bm":0}]},{"id":"comp_8","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"360 Rocket 1/2 1","refId":"comp_9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":45,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"360 Rocket 1/2 2","refId":"comp_11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":45,"op":94,"st":45,"bm":0}]},{"id":"comp_9","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 9","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Right Wing move","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[49.667,28.282,0],"to":[6.096,0,0],"ti":[-6.096,0,0]},{"t":48,"s":[86.243,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"s","pt":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[-2.053,0.065],[-0.362,1.329],[5.317,20.534],[0,0],[3.292,-12.714],[-0.898,-3.294],[-1.072,-0.034]],"o":[[0,0],[1.072,-0.034],[0.898,-3.294],[-3.292,-12.714],[0,0],[-5.317,20.534],[0.362,1.329],[2.053,0.066]],"v":[[-18.859,49.856],[-13.963,49.856],[-12.004,47.236],[-9.067,-2.546],[-18.859,-20.231],[-28.652,-2.546],[-25.714,47.236],[-23.756,49.856]],"c":true}]},{"t":48,"s":[{"i":[[0,0],[-2.677,0.067],[-0.473,1.368],[6.933,21.14],[0,0],[4.293,-13.089],[-1.171,-3.391],[-1.398,-0.035]],"o":[[0,0],[1.398,-0.035],[1.172,-3.391],[-4.293,-13.089],[0,0],[-6.933,21.14],[0.472,1.368],[2.677,0.067]],"v":[[-13.756,50.889],[-7.371,50.889],[-4.817,48.191],[-0.986,-3.058],[-13.756,-21.266],[-26.525,-3.058],[-22.694,48.191],[-20.141,50.889]],"c":true}]}],"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.268,38.004],[0.017,52.875],[2.094,37.765],[3.026,26.501]],"c":true}]},{"t":48,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":3,"nm":"Null 1","parent":1,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Rocket Matte 1","parent":3,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[52.592,48.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Rocket Window 1","parent":3,"tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[12.972,42.556,0],"to":[6.167,0,0],"ti":[-6.167,0,0]},{"t":48,"s":[49.972,42.556,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.505,-2.505],[2.505,-2.505],[2.505,2.505],[-2.505,2.505]],"o":[[2.505,2.505],[-2.505,2.505],[-2.505,-2.505],[2.505,-2.505]],"v":[[7.085,-10.791],[7.085,-1.715],[-1.99,-1.715],[-1.99,-10.791]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[4.218,4.218],[4.218,-4.218],[-4.218,-4.218],[-4.218,4.218]],"o":[[-4.218,-4.218],[-4.218,4.218],[4.218,4.218],[4.218,-4.218]],"v":[[10.19,-13.895],[-5.095,-13.895],[-5.095,1.39],[10.19,1.39]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Window","parent":3,"td":1,"refId":"comp_10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Reflection","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":26,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[24.908,124,0],"to":[40.667,0,0],"ti":[-40.667,0,0]},{"t":84,"s":[268.908,124,0]}],"ix":2},"a":{"a":0,"k":[94.5,19.5,0],"ix":1},"s":{"a":0,"k":[52.003,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[19,233],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[113.5,19.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[28,230],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.780391977348,0.827450980392,0.937255021638,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[80,18],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"Window 2","parent":3,"refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":3,"nm":"Wings","parent":11,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":0,"k":[-1.5,-2.165,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Rocket","parent":3,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[52.592,48.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[11.809,-5.487],[0,0],[0,0]],"o":[[0,0],[5.487,-11.809],[0,0]],"v":[[8.502,-30.404],[26.699,-12.207],[29.643,-33.348]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.835294117647,0.835294117647,0.835294117647,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-23.622,11.579],[-26.401,12.506],[-16.211,22.695],[-15.285,19.916]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.725490196078,0.725490196078,0.725490196078,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":2,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Left Wing move","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[49.667,28.282,0],"to":[-5.985,0,0],"ti":[5.985,0,0]},{"t":48,"s":[13.758,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[-266,266,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.205,38.004],[-0.03,52.875],[2.157,37.765],[3.026,26.501]],"c":true}]},{"t":48,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":-12,"bm":0}]},{"id":"comp_10","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Rocket Matte 2","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":85,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Rocket Window 2","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[51.504,130.199,0],"to":[16.403,0,0],"ti":[-35.023,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":48,"s":[149.924,130.199,0],"to":[35.023,0,0],"ti":[-18.62,0,0]},{"t":84,"s":[261.644,130.199,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":48,"s":[266,266,100]},{"t":84,"s":[170.24,266,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.195,-3.195],[3.195,-3.195],[3.195,3.195],[-3.195,3.195]],"o":[[3.195,3.195],[-3.195,3.195],[-3.195,-3.195],[3.195,-3.195]],"v":[[8.337,-12.042],[8.337,-0.463],[-3.242,-0.463],[-3.242,-12.042]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.686274509804,0.933333333333,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3b","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":85,"st":-12,"bm":0}]},{"id":"comp_11","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 9","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Right Wing move","parent":7,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":1,"y":0},"t":0,"s":[86.243,28.282,0],"to":[-6.096,0,0],"ti":[6.096,0,0]},{"t":48,"s":[49.667,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"s","pt":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":1,"y":0},"t":0,"s":[{"i":[[0,0],[-2.677,0.067],[-0.473,1.368],[6.933,21.14],[0,0],[4.293,-13.089],[-1.171,-3.391],[-1.398,-0.035]],"o":[[0,0],[1.398,-0.035],[1.172,-3.391],[-4.293,-13.089],[0,0],[-6.933,21.14],[0.472,1.368],[2.677,0.067]],"v":[[-13.756,50.889],[-7.371,50.889],[-4.817,48.191],[-0.986,-3.058],[-13.756,-21.266],[-26.525,-3.058],[-22.694,48.191],[-20.141,50.889]],"c":true}]},{"t":48,"s":[{"i":[[0,0],[-2.053,0.065],[-0.362,1.329],[5.317,20.534],[0,0],[3.292,-12.714],[-0.898,-3.294],[-1.072,-0.034]],"o":[[0,0],[1.072,-0.034],[0.898,-3.294],[-3.292,-12.714],[0,0],[-5.317,20.534],[0.362,1.329],[2.053,0.066]],"v":[[-18.859,49.856],[-13.963,49.856],[-12.004,47.236],[-9.067,-2.546],[-18.859,-20.231],[-28.652,-2.546],[-25.714,47.236],[-23.756,49.856]],"c":true}]}],"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":1,"y":0},"t":0,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]},{"t":48,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.268,38.004],[0.017,52.875],[2.094,37.765],[3.026,26.501]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":3,"nm":"Null 1","parent":1,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"Reverse Window Matte","td":1,"refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[150,150,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[-37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Reflection","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":26,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":-28,"s":[24.908,124,0],"to":[40.667,0,0],"ti":[-40.667,0,0]},{"t":56,"s":[268.908,124,0]}],"ix":2},"a":{"a":0,"k":[94.5,19.5,0],"ix":1},"s":{"a":0,"k":[-52.003,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[19,233],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[113.5,19.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[28,230],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.780391977348,0.827450980392,0.937255021638,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":1,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[80,18],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Reverse Window","parent":3,"refId":"comp_12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,50,0],"ix":2},"a":{"a":0,"k":[150,150,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"w":300,"h":300,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":3,"nm":"Wings","parent":8,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":0,"k":[-1.5,-2.165,0],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[37.594,37.594,100],"ix":6}},"ao":0,"ip":0,"op":49,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Rocket","parent":3,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[52.592,48.779,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[11.809,-5.487],[0,0],[0,0]],"o":[[0,0],[5.487,-11.809],[0,0]],"v":[[8.502,-30.404],[26.699,-12.207],[29.643,-33.348]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.835294117647,0.835294117647,0.835294117647,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-23.622,11.579],[-26.401,12.506],[-16.211,22.695],[-15.285,19.916]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.725490196078,0.725490196078,0.725490196078,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":2,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":2,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Left Wing move","parent":7,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":1,"y":0},"t":0,"s":[13.758,28.282,0],"to":[5.985,0,0],"ti":[-5.985,0,0]},{"t":48,"s":[49.667,28.282,0]}],"ix":2},"a":{"a":0,"k":[-0.125,17.539,0],"ix":1},"s":{"a":0,"k":[-266,266,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":1,"y":0},"t":0,"s":[{"i":[[4.021,4.242],[0,0],[0,0],[-1.292,-1.131],[-0.408,-2.262],[-0.967,0],[-1.027,11.647]],"o":[[-2.765,-2.917],[0,0],[0,0],[1.73,1.514],[1.265,7.02],[0.968,0],[0.276,-3.136]],"v":[[5.676,23.477],[-0.525,18.075],[-1.59,34.87],[0.978,37.117],[4.279,42.949],[6.377,51.596],[9.835,35.288]],"c":true}]},{"t":48,"s":[{"i":[[0,1.313],[0,-3.25],[-0.242,-3.035],[-0.424,-3.953],[-0.601,0],[-0.58,7.827],[-0.166,3.335]],"o":[[0,-3.312],[0,1.147],[0.267,3.35],[0.826,7.71],[0.617,0],[0.289,-3.897],[0.141,-2.848]],"v":[[3.25,20],[-3.5,20],[-3.109,26.604],[-2.205,38.004],[-0.03,52.875],[2.157,37.765],[3.026,26.501]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":49,"st":-12,"bm":0}]},{"id":"comp_12","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Rocket Matte 3","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":669,"st":-12,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Rocket Window 1","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":0,"s":[149.924,130.199,0],"to":[-16.403,0,0],"ti":[16.403,0,0]},{"t":48,"s":[51.504,130.199,0]}],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[266,266,100]},{"t":48,"s":[181,266,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.505,-2.505],[2.505,-2.505],[2.505,2.505],[-2.505,2.505]],"o":[[2.505,2.505],[-2.505,2.505],[-2.505,-2.505],[2.505,-2.505]],"v":[[7.085,-10.791],[7.085,-1.715],[-1.99,-1.715],[-1.99,-10.791]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[4.218,4.218],[4.218,-4.218],[-4.218,-4.218],[-4.218,4.218]],"o":[[-4.218,-4.218],[-4.218,4.218],[4.218,4.218],[4.218,-4.218]],"v":[[10.19,-13.895],[-5.095,-13.895],[-5.095,1.39],[10.19,1.39]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":711,"st":-12,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Rocket Matte 2","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-45,"ix":10},"p":{"a":0,"k":[156.894,146.751,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[266,266,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.988,-1.896],[-1.283,0.597],[-9.49,19.549],[0,0],[12.104,-5.876],[1.479,-3.179],[-0.99,-1.038]],"o":[[0,0],[1.038,0.99],[3.179,-1.479],[5.876,-12.104],[0,0],[-19.549,9.49],[-0.597,1.283],[1.896,1.988]],"v":[[-19.916,16.211],[-15.285,20.843],[-11.579,20.843],[26.401,-11.579],[29.643,-33.348],[7.874,-30.106],[-24.548,7.874],[-24.548,11.579]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.780392169952,0.827450990677,0.937254905701,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":669,"st":-12,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Rocket Window 2","parent":2,"tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[2.547,-6.253,0],"ix":2},"a":{"a":0,"k":[2.547,-6.253,0],"ix":1},"s":{"a":0,"k":[98,98,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-3.195,-3.195],[3.195,-3.195],[3.195,3.195],[-3.195,3.195]],"o":[[3.195,3.195],[-3.195,3.195],[-3.195,-3.195],[3.195,-3.195]],"v":[[8.337,-12.042],[8.337,-0.463],[-3.242,-0.463],[-3.242,-12.042]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.686274509804,0.933333333333,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3b","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":669,"st":-12,"bm":0}]},{"id":"comp_13","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Streak 42","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-181.5,-1038,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Streak 41","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-14,-1157,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Streak 40","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[86,-1095,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Streak 39","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-15,-1037,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Streak 38","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[53,-984,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Streak 37","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143,-973,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Streak 36","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143,-848,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Streak 35","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[44,-809,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Streak 34","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-114,-797,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Streak 33","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-48,-778,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Streak 32","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-22,-901,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Streak 31","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-80,-969,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Streak 30","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-153,-906,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Streak 29","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-107.5,-1078.5,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Streak 28","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-34,-668,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Streak 46","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-177.245,-702.167,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Streak 45","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[131.054,-702.167,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"Streak 27","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[66,-606,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"Streak 26","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-35,-548,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"Streak 25","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[33,-495,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"Streak 24","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[123,-484,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"Streak 44","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-190.955,-245.863,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"Streak 43","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[81.988,-269.905,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"Streak 23","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[123,-359,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":25,"ty":4,"nm":"Streak 22","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[24,-320,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"Streak 21","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-134,-308,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"Streak 20","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-68,-289,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":28,"ty":4,"nm":"Streak 19","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-42,-412,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":29,"ty":4,"nm":"Streak 18","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-100,-480,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":30,"ty":4,"nm":"Streak 17","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-173,-417,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":31,"ty":4,"nm":"Streak 16","parent":32,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-127.5,-589.5,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":32,"ty":4,"nm":"Streak 15","parent":47,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-131.5,-36.5,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":33,"ty":4,"nm":"Streak 14","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-14,-206,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":34,"ty":4,"nm":"Streak 13","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[86,-144,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":35,"ty":4,"nm":"Streak 12","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-15,-86,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":36,"ty":4,"nm":"Streak 11","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[53,-33,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":37,"ty":4,"nm":"Streak 10","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143,-22,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":38,"ty":4,"nm":"Streak 9","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143,103,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":39,"ty":4,"nm":"Streak 8","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[44,142,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":40,"ty":4,"nm":"Streak 7","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-114,154,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":41,"ty":4,"nm":"Streak 6","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-48,173,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":42,"ty":4,"nm":"Streak 5","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-22,50,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":43,"ty":4,"nm":"Streak 4","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-80,-18,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":44,"ty":4,"nm":"Streak 3","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-153,45,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":45,"ty":4,"nm":"Streak 2","parent":46,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-107.5,-127.5,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":46,"ty":4,"nm":"Streak 1","parent":47,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-131.5,-36.5,0],"ix":2},"a":{"a":0,"k":[-181.5,-87,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-181.5,-120],[-181.5,-54]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.141176006841,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":47,"ty":3,"nm":"Streak Controll","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":45,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":0,"s":[250,255,0],"to":[-105.333,98.5,0],"ti":[105.333,-98.5,0]},{"t":299,"s":[-382,846,0]}],"ix":2},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":300,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Circle Matte","parent":6,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,0,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-33.638,-33.638],[33.638,-33.638],[33.638,33.638],[-33.638,33.638]],"o":[[33.638,33.638],[-33.638,33.638],[-33.638,-33.638],[33.638,-33.638]],"v":[[58.359,-60.676],[58.359,61.138],[-63.454,61.138],[-63.454,-60.676]],"c":true},"ix":2},"nm":"Circle","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"gf","o":{"a":0,"k":100,"ix":10},"r":1,"bm":0,"g":{"p":3,"k":{"a":0,"k":[0,0.627,0.357,0.855,0.5,0.406,0.541,0.773,1,0.184,0.725,0.69],"ix":9}},"s":{"a":0,"k":[-60,58.5],"ix":5},"e":{"a":0,"k":[58,-60.5],"ix":6},"t":1,"nm":"Circle Gradient Fill 1","mn":"ADBE Vector Graphic - G-Fill","hd":false}],"ip":0,"op":300,"st":-41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Rocket","tt":1,"refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[104.5,103.5,0],"ix":2},"a":{"a":0,"k":[104.5,103.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":209,"h":207,"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Circle Matte 2","parent":6,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[0,0,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-33.638,-33.638],[33.638,-33.638],[33.638,33.638],[-33.638,33.638]],"o":[[33.638,33.638],[-33.638,33.638],[-33.638,-33.638],[33.638,-33.638]],"v":[[58.359,-60.676],[58.359,61.138],[-63.454,61.138],[-63.454,-60.676]],"c":true},"ix":2},"nm":"Circle","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"gf","o":{"a":0,"k":100,"ix":10},"r":1,"bm":0,"g":{"p":3,"k":{"a":0,"k":[0,0.627,0.357,0.855,0.5,0.406,0.541,0.773,1,0.184,0.725,0.69],"ix":9}},"s":{"a":0,"k":[-60,58.5],"ix":5},"e":{"a":0,"k":[58,-60.5],"ix":6},"t":1,"nm":"Circle Gradient Fill 1","mn":"ADBE Vector Graphic - G-Fill","hd":false}],"ip":0,"op":300,"st":-41,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"Stars","tt":1,"refId":"comp_13","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[100.329,101.879,0],"ix":2},"a":{"a":0,"k":[250,247.5,0],"ix":1},"s":{"a":0,"k":[50,50,100],"ix":6}},"ao":0,"w":500,"h":495,"ip":-4,"op":296,"st":-4,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Circle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[106.547,102.769,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.254,0.254,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,15.278]},"t":0,"s":[0,0,100]},{"i":{"x":[0.724,0.724,0.833],"y":[1,1,1]},"o":{"x":[0.277,0.277,0.167],"y":[0,0,0]},"t":15,"s":[110,110,100]},{"t":33,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-33.638,-33.638],[33.638,-33.638],[33.638,33.638],[-33.638,33.638]],"o":[[33.638,33.638],[-33.638,33.638],[-33.638,-33.638],[33.638,-33.638]],"v":[[58.359,-60.676],[58.359,61.138],[-63.454,61.138],[-63.454,-60.676]],"c":true},"ix":2},"nm":"Circle","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.001753171752,0.046799364277,0.149019607843,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":300,"st":-41,"bm":0}],"markers":[]}'
    )
})


/**
 *  Loading manager
 */
let loadOk = null
let loadOkFirst = null

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {

        loadOkFirst = 1
        window.setTimeout(() => {
            gsap.to(overlayMaterial.uniforms.uAlpha, {
                duration: 3,
                value: 0,
                delay: 1

            })
            loadingBarElement.classList.add('ended')
            loadingBarElement.style.transform = ''


        }, 2500)
        window.setTimeout(() => {
            sectionMain.style.display = "block"
            playerLottie.style.display = "none"

            const TL = gsap.timeline({
                paused: true
            });
            sectionMain.style = "visibility: visible;"
            TL

                .staggerFrom(divLogo, 1, {
                    left: -400,
                    width: 0,
                    ease: "power2.out"
                }, '-=3')
                .staggerFrom(medias, 1, {
                    right: -900,
                    opacity: 0,
                    ease: "power2.out"
                }, 0.2, '-=1')
                .staggerFrom(titreSpans, 2, {
                    top: -50,
                    opacity: 0,
                    ease: "power2.out"
                }, 0.3)
                .from(l1, 1, {
                    width: 0,
                    ease: "power2.out"
                }, '-=2')


            TL.play();


        }, 2500)
        window.setTimeout(() => {
            loadOk = 1;
        }, 6000)
        // PLace tout les modeles dans la scenes après leur chargement
        window.setTimeout(() => {
            if (earth, moon, jupiter, venus, uranus, neptune, sun, saturne, mercure, mars, asteroide1, asteroide2,
                asteroides3, asteroides4, asteroides5, asteroides6, asteroides7, asteroides8, asteroides9, asteroides10, theSun, particles, planeteRooms,
                stationSpatial, flecheProjects, flecheCasino, flecheProjectMove, flecheProjectMoveRetour, texteStudio, satelitte, spaceInvader, screenSI,
                leftButtonSi, rightButtonSi, spaceButtonSi, spaceShip, reacteur, tableauStudio, ufo, sofa
            ) {
                flechesProjectsGroupe.add(flecheProjects)
                flechesRotates.add(flecheCasino)
                rooms.add(planeteRooms)
                screenSIGroup.add(screenSI)
                satelittes.add(stationSpatial)
                flecheProjectMoveGroup.add(flecheProjectMove)
                flecheProjectMoveRetourGroup.add(flecheProjectMoveRetour)
                spaceInvaderGroup.add(spaceInvader)
                texteStudioGroup.add(texteStudio)
                spaceButtonGroup.add(spaceButtonSi)
                leftButtonGroup.add(leftButtonSi)
                rightButtonGroup.add(rightButtonSi)
                spaceShipGroup.add(spaceShip)
                reacteurGroup.add(reacteur)
                tableauStudioGroup.add(tableauStudio)
                ufoGroup.add(ufo)
                sofaGroup.add(sofa)
                //planeteGroup.add(spaceInvader, spaceButtonSi, leftButtonSi, rightButtonSi, tableauStudio, planeteRooms)
                solarSystem.add(earth, jupiter, venus, uranus, neptune, saturne, mercure, mars, moon)
                asteroides.add(satelitte, asteroide1, asteroide2, asteroides3, asteroides4, asteroides5, asteroides6, asteroides7, asteroides8, asteroides9, asteroides10)
                spaceInvader.children[0].material = screenMaterial
                solarSystem.position.x = 20
                solarSystem.position.z = -70
                solarSystem.rotation.y = 90
                solarSystem.rotation.x = -0.4

                scene.add(solarSystem, asteroides, theSun, particles, rooms, satelittes, flechesProjectsGroupe, flechesRotates,
                    flecheProjectMoveGroup, flecheProjectMoveRetourGroup, spaceInvaderGroup, texteStudioGroup, rightButtonGroup,
                    leftButtonGroup, spaceButtonGroup, spaceShipGroup, reacteurGroup, tableauStudioGroup, ufoGroup, sofaGroup)
            }

        }, 0)

        //PLace toutes les lights dans la scene après leur chargement
        window.setTimeout(() => {

            scene.add(targetObject);
            scene.add(hemiLight, spotLight)
            scene.add(
                ambiantLight, casinoLight1, skyLight1, skyLight2, skyLight3,
                skyLight4, skyLight5, skyLight6, skyLight10,
                skyLight7, skyLight8, spotLightRooms, targetObjectRooms,
                skyLight9, projectLight, projectMoveLight, projectMoveRetourLight,
                chevetLight
                /*skyLight1Helper, skyLight1Helper2, skyLight1Helper3, skyLight1Helper4,
                skyLight1Helper5, skyLight1Helper6, skyLight1Helper7, skyLight1Helper8*/
            );
        }, 0)
        //PLace tout les textes dans la scene après leur chargement
        if (textMesh4, textMesh6) {
            scene.add(textMesh4, textMesh6)
            textMesh1.position.x = -0.8
            textMesh5.position.set(-0.53, -0.15, 0)

            textMesh4.position.set(-7, 0, -65.7)
            textMesh4.rotation.y = 1

            textMesh6.position.set(-7, -0.2, -65.7)
            textMesh6.rotation.y = 1
        }
        //Animations load
        //fusée
        setTimeout(() => {
            reacteurAnim.forEach((clip) => {
                mixer6.clipAction(clip).play();
            });
            spaceShipAnim.forEach((clip) => {
                mixer5.clipAction(clip).play();
            });

        }, 2000)

    },

    // Progress
    (itemUrl, itemsLoaded, itemsTotal) => {
        const progressRatio = itemsLoaded / itemsTotal
        //loadingBarElement.style.transform = `scaleX(${progressRatio})`
        //Lottie
        playerLottie.style.display = "block"
        //animationLottie.play()



    }
)




// Texture

const textureLoader = new THREE.TextureLoader(loadingManager)
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter

//Canvas SI

const canvasSI = document.querySelector('.canvasSI')
canvasSI.width = 1500
canvasSI.height = 1500

const texture = new THREE.CanvasTexture(canvasSI);
texture.rotation = -Math.PI / 2;
texture.center = new THREE.Vector2(0.5, 0.5);
const screenMaterial = new THREE.MeshBasicMaterial({
    map: texture
})


const titreSpans = document.querySelectorAll('h1 span');
const divLogo = document.querySelector('.lignes');
const medias = document.querySelectorAll('.bulle');
const l1 = document.querySelector('.l1');
const lanterne = document.querySelector('.logo');
const page = document.querySelector('.page')



/**
 *  Liens et reload de page
 */

document.getElementById("lienRoue").onclick = function () {
    setTimeout(() => {
            location.reload(true);

        },
        500)
}
document.getElementById("instaLogo").onclick = function () {
    setTimeout(() => {
            location.assign("https://www.instagram.com/lanterne_rouge_studio/")

        },
        500)
}
document.getElementById("fbLogo").onclick = function () {
    setTimeout(() => {
            location.assign("https://www.facebook.com/LanterneRougeStudio")

        },
        500)
}


/*window.addEventListener("load", () => {
})*/


//Evenement icones passage de la souris

const fbLogo = document.getElementById('fbLogo')
const instaLogo = document.getElementById('instaLogo')
const musicLogo = document.getElementById('musicLogo')

fbLogo.addEventListener("mouseenter", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

fbLogo.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})

fbLogo.addEventListener("touchstart", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

fbLogo.addEventListener("touchend", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})

fbLogo.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

})

fbLogo.addEventListener("touch", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(fbLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

})

burger.addEventListener("mouseenter", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: -15
    }, '-=2')
    TL.play();

})

burger.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: 0
    }, '-=2')
    TL.play();

})

burger.addEventListener("touchstart", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: -15
    }, '-=2')
    TL.play();

})

burger.addEventListener("touchend", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: 0
    }, '-=2')
    TL.play();

})

burger.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: 360
    }, '-=2')
    TL.play();


})

burger.addEventListener("touch", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(burger, {
        rotate: 360
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("mouseenter", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("touchstart", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("touchend", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

})

instaLogo.addEventListener("touch", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(instaLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

})

musicLogo.addEventListener("mouseenter", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

musicLogo.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})
musicLogo.addEventListener("touchstart", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: -15
    }, '-=2')
    TL.play();

})

musicLogo.addEventListener("touchend", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: 0
    }, '-=2')
    TL.play();

})

musicLogo.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

    if (audioFondOk === true) {
        audioFond.pause()
        audioFondOk = false
        if (zoomSpaceInvader === 1) {
            audioBackground.pause()
        }
    } else if (audioFondOk === false) {
        audioFond.play()
        audioFondOk = true
        if (zoomSpaceInvader === 1) {
            audioBackground.play()
        }
    }

})

musicLogo.addEventListener("touch", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(musicLogo, {
        rotate: 360
    }, '-=2')
    TL.play();

    if (audioFondOk === null) {
        audioFond.pause()
        audioFondOk = 1
    } else if (audioFondOk === 1) {
        audioFond.play()
        audioFondOk = null
    }

})

/*const mainContainer = document.getElementById("mainContainer")
// Scroll event
function elementPosition(a) {
    let b = a.getBoundingClientRect();
    return {
        clientX: a.offsetLeft,
        clientY: a.offsetTop,
        viewportX: (b.x || b.left),
        viewportY: (b.y || b.top)
    }
}

window.addEventListener("click", () => {
    let positions = elementPosition(mainContainer);

    window.scrollTo({
        top: positions.clientY - 800,
        behavior: 'smooth',
    })
})*/


// evenement logo passage de la souris


let divLignes = document.getElementById("lignes");
const roueTourne = document.getElementById("tourne");
var ok = true;

divLignes.addEventListener("mouseenter", function () {

    //if(ok) {
    ok = false;
    const TL = gsap.timeline({
        paused: true
    });
    // TL.to(l1, {width: 0, ease: "power2.out"}, '-=2')
    TL.to(roueTourne, {
        rotate: 180,
        ease: "power2.out"
    });
    TL.play();

    //timeout de valid pour ne pas faire buger l'animation
    //setTimeout(function() {ok = true}, 500);    
    //}

})

divLignes.addEventListener("mouseenter", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(lanterne, {
        rotate: -15
    })
    TL.play();

})

divLignes.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    /**   TL.to(l1,{width: 180, ease: "power2.out"});*/
    TL.to(roueTourne, {
        rotate: 0,
        ease: "power2.out"
    });
    TL.play();
})

divLignes.addEventListener("mouseleave", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(lanterne, {
        rotate: 0
    })
    TL.play();
})

divLignes.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(lanterne, {
        rotate: 10
    })
    TL.play();

})

divLignes.addEventListener("click", function () {

    const TL = gsap.timeline({
        paused: true
    });
    TL.to(roueTourne, {
        rotate: -360
    })
    TL.play();

})


/**
 * Debug
 */

const parameters = {
    materialColor: '#ffeded'
}

let stats = new Stats();
stats.showPanel(1); // 0: fps, 1: ms, 2: mb, 3+: custom
//document.body.appendChild(stats.dom);



/**
 * Test objects
 */



const objectsDistance = 4
const toonMaterial = new THREE.MeshToonMaterial({
    color: '#ff0000',
    gradientMap: gradientTexture
})

const textSunMaterial = new THREE.MeshToonMaterial({
    color: '#ff0000',
    gradientMap: gradientTexture
})




// PLANE

// TEXTURES

/* const waterBaseColor = textureLoader.load("./textures/water/Water_002_COLOR.jpg");
const waterNormalMap = textureLoader.load("./textures/water/Water_002_NORM.jpg");
const waterHeightMap = textureLoader.load("./textures/water/Water_002_DISP.png");
const waterRoughness = textureLoader.load("./textures/water/Water_002_ROUGH.jpg");
const waterAmbientOcclusion = textureLoader.load("./textures/water/Water_002_OCC.jpg"); */


let sunMaterial = new THREE.MeshToonMaterial({
        color: 'ffffff',
        gradientMap: gradientTexture
    }

)
const geometry = new THREE.SphereGeometry(6, 128, 128);



const theSun = new THREE.Mesh(geometry,
    new THREE.MeshStandardMaterial({
        sunMaterial

    }));



theSun.position.set(-12, 0, -70)


/**
 *  ////////////////// SUN WAVE ////////////////////////////////////////////////////////////////////////
 */

const count = geometry.attributes.position.count;
const position_clone = JSON.parse(JSON.stringify(geometry.attributes.position.array));
const normals_clone = JSON.parse(JSON.stringify(geometry.attributes.normal.array));
let damping = 0.03;






/**
 *  Modeles 3D
 */

const gltfLoader = new GLTFLoader(loadingManager)
let earth = null
let moon = null
let sun = null
let mercure = null
let venus = null
let uranus = null
let neptune = null
let mars = null
let saturne = null
let jupiter = null
let asteroide1 = null
let asteroide2 = null
let asteroides3 = null
let asteroides4 = null
let asteroides5 = null
let asteroides6 = null
let asteroides7 = null
let asteroides8 = null
let asteroides9 = null
let asteroides10 = null
let hackerRoom = null
let musicCollective = null
let asteroidRoom = null
let planeteRooms = null
let flecheCasino = null
let flecheProjects = null
let flecheProjectMove = null
let flecheProjectMoveRetour = null
let stationSpatial = null
let satelitte = null
let spaceShip = null
let screenSI = null
let leftButtonSi = null
let rightButtonSi = null
let spaceButtonSi = null
let textMesh1 = null
let textMesh4 = null
let textMesh5 = null
let textMesh6 = null
let tableauStudio = null



function ch_zoom() {
    document.body.style.zoom = "100%";
    setTimeout(ch_zoom, 100);
}

/*let scrolldelay = null
let scrollOk = null

function pageScroll() {
    window.scrollBy(0, 5);
    scrolldelay = setTimeout(pageScroll, 5);
}

window.addEventListener("scroll", () => {
    if (scrollOk === null) {
        pageScroll()
        scrollOk = 1

    }
})*/


// Solar System ////////////////////////

gltfLoader.load(
    '/models/earth2.glb',
    (gltf) => {
        console.log('Earth success')
        earth = gltf.scene
        earth.position.x = 13
        earth.position.z = -30

        earth.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/jupiter2.glb',
    (gltf) => {
        console.log('Jupiter success')
        jupiter = gltf.scene
        jupiter.position.x = 13
        jupiter.position.z = -30
        jupiter.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/mars2.glb',
    (gltf) => {
        console.log('mars success')
        mars = gltf.scene
        mars.position.x = 13
        mars.position.z = -30
        mars.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/mercure2.glb',
    (gltf) => {
        console.log('mercure success')
        mercure = gltf.scene
        mercure.position.x = 13
        mercure.position.z = -30
        mercure.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/neptune2.glb',
    (gltf) => {
        console.log('Neptune success')
        neptune = gltf.scene
        neptune.position.x = 13
        neptune.position.z = -30
        neptune.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/saturn2.glb',
    (gltf) => {
        console.log('Saturn success')
        saturne = gltf.scene
        saturne.position.x = 30
        saturne.position.y = 0
        saturne.position.z = -30
        saturne.scale.set(1.3, 1.3, 1.3)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/sun.glb',
    (gltf) => {
        console.log('sun success')
        sun = gltf.scene
        sun.position.x = 13
        sun.position.z = -30
        sun.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/uranus2.glb',
    (gltf) => {
        console.log('uranus success')
        uranus = gltf.scene
        uranus.position.x = 13
        uranus.position.z = -30
        uranus.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/venus2.glb',
    (gltf) => {
        console.log('venus success')
        venus = gltf.scene
        venus.position.x = 13
        venus.position.z = -30
        venus.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/moon.glb',
    (gltf) => {
        console.log('moon success')
        moon = gltf.scene
        moon.position.x = 13
        moon.position.z = -30
        moon.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

////////////////////////////////////////

/**
 * Text geometry
 */
const loader = new FontLoader(loadingManager)
let textMeshes = new THREE.Group()

loader.load('fonts/Mogen_Bold.json', function (font) {

    textMesh1 = new THREE.Mesh(new TextGeometry('Lanterne Rouge', {
        font: font,
        size: 0.18,
        height: 0.1,
    }), toonMaterial)
    textMesh4 = new THREE.Mesh(new TextGeometry('Made by Grégoire Bigot', {
        font: font,
        size: 0.1,
        height: 0.05,
    }), textSunMaterial)
    textMesh6 = new THREE.Mesh(new TextGeometry('Music by Ryoji Ikeda', {
        font: font,
        size: 0.1,
        height: 0.05,
    }), textSunMaterial)
    textMesh5 = new THREE.Mesh(new TextGeometry('Creative studio', {
        font: font,
        size: 0.08,
        height: 0.05,
    }), toonMaterial)

    if (textMesh1, textMesh4, textMesh5, textMesh6) {


        textMeshes.add(textMesh1, textMesh5, textMesh4, textMesh6)
    }




});


/**
 * Particles
 */
// Geometry
const particlesCount = 3000
const positions = new Float32Array(particlesCount * 3)

for (let i = 0; i < particlesCount; i++) {
    positions[i * 3 + 0] = (Math.random() - 0.5) * 200
    positions[i * 3 + 1] = objectsDistance * 1 - Math.random() * objectsDistance * 4
    positions[i * 3 + 2] = (Math.random() - 0.5) * 150
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

// Material
const particlesMaterial = new THREE.PointsMaterial({
    color: "white",
    sizeAttenuation: true,
    size: 0.08
})

// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)


/**
 * Asteroides
 */


gltfLoader.load(
    '/models/rock1.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroide1 = gltf.scene
        asteroide1.position.set(0, 3, -15)
        asteroide1.scale.set(0.2, 0.4, 0.3)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

gltfLoader.load(
    '/models/rock2.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroide2 = gltf.scene
        asteroide2.position.set(-10, 9, -46)
        asteroide2.scale.set(1.5, 1.5, 1.5)
    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

gltfLoader.load(
    '/models/rock1.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides3 = gltf.scene
        asteroides3.position.set(-4, -1.5, -3)
        asteroides3.scale.set(0.2, 0.1, 0.2)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock2.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides4 = gltf.scene
        asteroides4.position.set(3, 0, 5)
        asteroides4.scale.set(0.8, 0.6, 0.7)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock1.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides5 = gltf.scene
        asteroides5.position.set(-10, 0, -23)
        asteroides5.scale.set(1, 1, 1)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock2.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides6 = gltf.scene
        asteroides6.position.set(9, 4, -25)
        asteroides6.scale.set(0.7, 0.8, 0.6)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

gltfLoader.load(
    '/models/rock1.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides7 = gltf.scene
        asteroides7.position.set(4.5, -6, -15)
        asteroides7.rotation.set(-15, -3, -23)
        asteroides7.scale.set(0.8, 0.5, 0.7)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock2.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides8 = gltf.scene
        asteroides8.position.set(3, -3, -30)
        asteroides8.scale.set(0.5, 0.5, 0.5)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock1.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides9 = gltf.scene
        asteroides9.position.set(-7, 1, -26)
        asteroides9.scale.set(0.7, 0.6, 0.5)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
gltfLoader.load(
    '/models/rock2.glb',
    (gltf) => {
        console.log('asteroide success')
        asteroides10 = gltf.scene
        asteroides10.position.set(-6, -5, -18)
        asteroides10.scale.set(0.5, 0.75, 0.6)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

///////////////////////////////////////////


// planete Rooms

let mixer;
gltfLoader.load(
    '/models/planeteRooms.glb',
    (gltf) => {
        console.log('planete Rooms success')
        planeteRooms = gltf.scene
        planeteRooms.rotation.set(0, -0.5, 0)
        planeteRooms.scale.set(0.5, 0.5, 0.5)
        planeteRooms.position.set(0.45, -11.3, -2)
        //asteroidRoom.applyMatrix(new THREE.Matrix4().makeTranslation(0, -7, -3))

        mixer = new THREE.AnimationMixer(gltf.scene);
        let actionAntenne = mixer.clipAction(gltf.animations[0]);
        actionAntenne.play();

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Tableau Studio
let mixer7;
let actionTableauStudio
const tableauStudioGroup = new THREE.Group()
gltfLoader.load(
    '/models/tableauStudio.glb',
    (gltf) => {
        console.log('tableau studio success')
        tableauStudio = gltf.scene
        tableauStudio.rotation.set(0, -0.5, 0)
        tableauStudio.scale.set(0.5, 0.5, 0.5)
        tableauStudio.position.set(0.45, -11.3, -2)
        //asteroidRoom.applyMatrix(new THREE.Matrix4().makeTranslation(0, -7, -3))


        mixer7 = new THREE.AnimationMixer(gltf.scene);
        actionTableauStudio = mixer7.clipAction(gltf.animations[0]);


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)



let mixer3;
let texteStudio;

// texte Studio

gltfLoader.load(
    '/models/texteStudioAnim.glb',
    (gltf) => {
        console.log('Texte studio success')
        texteStudio = gltf.scene
        texteStudio.rotation.set(0, -0.5, 0)
        texteStudio.scale.set(0.5, 0.5, 0.5)
        texteStudio.position.set(0.45, -11.3, -2)
        //asteroidRoom.applyMatrix(new THREE.Matrix4().makeTranslation(0, -7, -3))
        mixer3 = new THREE.AnimationMixer(gltf.scene);

        gltf.animations.forEach((clip) => {

            mixer3.clipAction(clip).play();



        });

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// UFO Event Anim
let mixer8;
let ufo
let ufoAll
const ufoGroup = new THREE.Group()
gltfLoader.load(
    '/models/ufo.glb',
    (gltf) => {
        console.log('UFO success')
        ufoAll = gltf
        ufo = gltf.scene
        ufo.rotation.set(0, -0.5, 0)
        ufo.scale.set(0.5, 0.5, 0.5)
        ufo.position.set(0.45, -11.3, -2)
        mixer8 = new THREE.AnimationMixer(gltf.scene);

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Canape Event Anim
let mixer9;
let sofa
let sofaAll
const sofaGroup = new THREE.Group()
gltfLoader.load(
    '/models/canape.glb',
    (gltf) => {
        console.log('UFO success')
        sofaAll = gltf
        sofa = gltf.scene
        sofa.rotation.set(0, -0.5, 0)
        sofa.scale.set(0.5, 0.5, 0.5)
        sofa.position.set(0.45, -11.3, -2)
        //asteroidRoom.applyMatrix(new THREE.Matrix4().makeTranslation(0, -7, -3))
        mixer9 = new THREE.AnimationMixer(gltf.scene);

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Screen Space Invaders
/*gltfLoader.load(
    '/models/screenSI.glb',
    (gltf) => {
        console.log('screenSI success')
        screenSI = gltf.scene
        screenSI.rotation.set(0, -0.5, 0)
        screenSI.scale.set(50, 50, 50)
        screenSI.position.set(0.45, -11.3, -2)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)*/

// space Invader 
let spaceInvader;
let mixer2;
let actionSpaceInvader
let actionSpaceInvaderScreen
gltfLoader.load(
    '/models/spaceInvaderAnim.glb',
    (gltf) => {
        console.log('space Invader success')
        spaceInvader = gltf.scene
        spaceInvader.rotation.set(0, -0.5, 0)
        spaceInvader.scale.set(0.5, 0.5, 0.5)
        spaceInvader.position.set(0.45, -11.3, -2)
        //asteroidRoom.applyMatrix(new THREE.Matrix4().makeTranslation(0, -7, -3))

        mixer2 = new THREE.AnimationMixer(gltf.scene);
        actionSpaceInvader = mixer2.clipAction(gltf.animations[0]);
        actionSpaceInvader.setLoop(THREE.LoopOnce);
        actionSpaceInvaderScreen = mixer2.clipAction(gltf.animations[1])
        actionSpaceInvaderScreen.setLoop(THREE.LoopOnce);


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// SCREEN SI (PAS UTILE)
/*gltfLoader.load(
    '/models/screenSI.glb',
    (gltf) => {
        console.log('screenSI success')
        screenSI = gltf.scene
        screenSI.rotation.set(0, -0.5, 0)
        screenSI.scale.set(0.5, 0.5, 0.5)
        screenSI.position.set(0.45, -11.3, -2)



    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)*/

// station spatial
gltfLoader.load(
    '/models/stationSpatial.glb',
    (gltf) => {
        console.log('station spatial success')
        stationSpatial = gltf.scene
        stationSpatial.rotation.set(0, -0.5, 0)
        stationSpatial.scale.set(0.5, 0.5, 0.5)
        stationSpatial.position.set(-3, 15, -28)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// satelitte
gltfLoader.load(
    '/models/satelitte.glb',
    (gltf) => {
        console.log('satelitte success')
        satelitte = gltf.scene
        satelitte.rotation.set(0, -0, 0)
        satelitte.scale.set(1, 1, 1)
        satelitte.position.set(-23, -3, -45)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Space Ship ////////////////////////////
let mixer5
let spaceShipAnim = null
gltfLoader.load(
    '/models/spaceship.glb',
    (gltf) => {
        console.log('Spaceship success')
        spaceShip = gltf.scene
        spaceShipAnim = gltf.animations
        spaceShip.rotation.set(0, -0.5, 0)
        spaceShip.scale.set(0.5, 0.5, 0.5)
        spaceShip.position.set(0.45, -11.3, -2)

        //Animation
        mixer5 = new THREE.AnimationMixer(gltf.scene);



    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)
let mixer6
let reacteur = null
let reacteurAnim
gltfLoader.load(
    '/models/reacteur.glb',
    (gltf) => {
        console.log('Reacteur success')
        reacteur = gltf.scene
        reacteurAnim = gltf.animations
        reacteur.rotation.set(0, -0.5, 0)
        reacteur.scale.set(0.5, 0.5, 0.5)
        reacteur.position.set(0.45, -11.3, -2)

        //Animation
        mixer6 = new THREE.AnimationMixer(gltf.scene);

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)



const solarSystem = new THREE.Group
const asteroides = new THREE.Group
const rooms = new THREE.Group

// Fleche casino
let flechesRotates = new THREE.Group()
let flechesProjectsGroupe = new THREE.Group()
let mixer4;
gltfLoader.load(
    '/models/Fleche.glb',
    (gltf) => {
        console.log('fleche Casino success')
        flecheCasino = gltf.scene
        flecheCasino.rotation.set(Math.PI / 2, 0, Math.PI * 2)
        flecheCasino.scale.set(4, 4, 4)
        flecheCasino.position.set(0, -4, -2)
        mixer4 = new THREE.AnimationMixer(gltf.scene);

        gltf.animations.forEach((clip) => {

            setTimeout(() => {
                gltf.children[clip].material.color.set('white')
            }, 200);



        });


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Fleche projects

gltfLoader.load(
    '/models/flecheProjects.glb',
    (gltf) => {
        console.log('fleche project success')
        flecheProjects = gltf.scene
        flecheProjects.rotation.set(Math.PI / 2 - 0.8, -0.8, 0)
        flecheProjects.scale.set(3.5, 3.5, 3.5)
        flecheProjects.position.set(0, -6.2, 0.2)


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Fleche projects Move

gltfLoader.load(
    '/models/flecheProjectMove.glb',
    (gltf) => {
        console.log('fleche project move success')
        flecheProjectMove = gltf.scene
        flecheProjectMove.rotation.set(Math.PI / 2, Math.PI + 0.8, 0)
        flecheProjectMove.scale.set(1.5, 1.5, 1.5)
        flecheProjectMove.position.set(-50, -5.4, -1)


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Fleche projects Move retour

gltfLoader.load(
    '/models/flecheProjectMove.glb',
    (gltf) => {
        console.log('fleche project move retour success')
        flecheProjectMoveRetour = gltf.scene
        flecheProjectMoveRetour.rotation.set(Math.PI / 2, Math.PI - 0.8, Math.PI)
        flecheProjectMoveRetour.scale.set(1.5, 1.5, 1.5)
        flecheProjectMoveRetour.position.set(50, -5.4, -1)


    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Left Button SI

gltfLoader.load(
    '/models/leftButtonSi.glb',
    (gltf) => {
        console.log('Left Buttom success')
        leftButtonSi = gltf.scene
        leftButtonSi.rotation.set(0, -0.5, 0)
        leftButtonSi.scale.set(0.5, 0.5, 0.5)
        leftButtonSi.position.set(0.45, -11.3, -2)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Right Button SI

gltfLoader.load(
    '/models/rightButtonSi.glb',
    (gltf) => {
        console.log('Left Button success')
        rightButtonSi = gltf.scene
        rightButtonSi.rotation.set(0, -0.5, 0)
        rightButtonSi.scale.set(0.5, 0.5, 0.5)
        rightButtonSi.position.set(0.45, -11.3, -2)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)

// Space Button SI

gltfLoader.load(
    '/models/spaceButtonSi.glb',
    (gltf) => {
        console.log('Left Button success')
        spaceButtonSi = gltf.scene
        spaceButtonSi.rotation.set(0, -0.5, 0)
        spaceButtonSi.scale.set(0.5, 0.5, 0.5)
        spaceButtonSi.position.set(0.45, -11.3, -2)

    },
    (progress) => {
        console.log('progress')
        console.log(progress)
    },
    (error) => {
        console.log('error')
        console.log(error)
    }
)


const satelittes = new THREE.Group()
const flecheProjectMoveGroup = new THREE.Group()
const flecheProjectMoveRetourGroup = new THREE.Group()
const spaceInvaderGroup = new THREE.Group()
const screenSIGroup = new THREE.Group()
const texteStudioGroup = new THREE.Group()
const leftButtonGroup = new THREE.Group()
const rightButtonGroup = new THREE.Group()
const spaceButtonGroup = new THREE.Group()
const spaceShipGroup = new THREE.Group()
const boutons = new THREE.Group()
const reacteurGroup = new THREE.Group()
const planeteGroup = new THREE.Group()


// Lights

//const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);

const ambiantLight = new THREE.AmbientLight(0xffffff, 2)

const hemiLight = new THREE.HemisphereLight(0xffeeb1, 0x090920, 4)
const hemiLightHelper = new THREE.HemisphereLightHelper(hemiLight)
hemiLight.position.set(-10, 0, -70)

const spotLight = new THREE.SpotLight(0xff0000, 2, 50, 2);
spotLight.position.set(0, 0, 20);
spotLight.rotation.x = Math.PI / 2
//const spotLightHelper = new THREE.SpotLightHelper(spotLight)
const targetObject = new THREE.Object3D();

spotLight.target = targetObject;

// Point light fleches
const casinoLight1 = new THREE.PointLight(0xffffff, 0.6, 5)
const casinoLight1Helper = new THREE.PointLightHelper(casinoLight1)
casinoLight1.position.set(0, -4, 0)
casinoLight1.visible = true

// Point light chevet studio
const chevetLight = new THREE.PointLight('orange', 0.8, 2)
const chevetLightHelper = new THREE.PointLightHelper(chevetLight)
chevetLight.position.set(-0.2, -5.5, -2.2)
chevetLight.visible = true

// Point light fleches Projects
const projectLight = new THREE.PointLight(0xffffff, 0.1, 5)
const projectLight1Helper = new THREE.PointLightHelper(projectLight)
projectLight.position.set(0, -6, 1)
projectLight.visible = true
projectLight.intensity = 8

// Point light fleches Projects Move
const projectMoveLight = new THREE.PointLight(0xffffff, 0.1, 5)
const projectMoveLightHelper = new THREE.PointLightHelper(projectMoveLight)
projectMoveLight.position.set(-50, -5.5, 0)
projectMoveLight.visible = true

// Point light fleches Projects Move Retour
const projectMoveRetourLight = new THREE.PointLight(0xffffff, 0.1, 5)
const projectMoveRetourLightHelper = new THREE.PointLightHelper(projectMoveRetourLight)
projectMoveRetourLight.position.set(50, -5.5, 0)
projectMoveRetourLight.visible = true


// Point Light asteroide
const skyLight1 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper = new THREE.PointLightHelper(skyLight1)
skyLight1.position.set(-3, 5, -18)
skyLight1.visible = true

// Point Light asteroide 2
const skyLight2 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper2 = new THREE.PointLightHelper(skyLight2)
skyLight2.position.set(-6, 5, -40)
skyLight2.visible = true

// Point Light asteroide 3
const skyLight3 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper3 = new THREE.PointLightHelper(skyLight3)
skyLight3.position.set(-5, -2, -4)
skyLight3.visible = true

// Point Light asteroide 4
const skyLight4 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper4 = new THREE.PointLightHelper(skyLight4)
skyLight4.position.set(3, 0, 8)
skyLight4.visible = true

// Point Light asteroide 5
const skyLight5 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper5 = new THREE.PointLightHelper(skyLight5)
skyLight5.position.set(-10, 0, -26)
skyLight5.visible = true

// Point Light asteroide 6
const skyLight6 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper6 = new THREE.PointLightHelper(skyLight6)
skyLight6.position.set(9, 4, -28)
skyLight6.visible = true

// Point Light asteroide 7
const skyLight7 = new THREE.PointLight(0xffffff, 15, 15)
const skyLight1Helper7 = new THREE.PointLightHelper(skyLight7)
skyLight7.position.set(2.5, -6, -21)
skyLight7.visible = true

// Point Light asteroide 
const skyLight8 = new THREE.PointLight(0xffffff, 10, 10)
const skyLight1Helper8 = new THREE.PointLightHelper(skyLight8)
skyLight8.position.set(-1, -3, -30)
skyLight8.visible = true

// Point Light satelitte 
const skyLight9 = new THREE.PointLight(0xffffff, 20, 10)
const skyLight1Helper9 = new THREE.PointLightHelper(skyLight9)
skyLight9.position.set(3, 7, -43)
skyLight9.visible = true

// Point Light PALMIER 
const skyLight10 = new THREE.PointLight('0xffffff', 100, 200, 1)
const skyLight1Helper10 = new THREE.PointLightHelper(skyLight10)
skyLight10.position.set(-10, 0, -70)
skyLight10.visible = true

// spot light Rooms
const spotLightRooms = new THREE.SpotLight("blue", 10, 20, 1);
spotLightRooms.position.set(0, -5.5, 2);
spotLightRooms.rotation.x = 0
const spotLightHelperRooms = new THREE.SpotLightHelper(spotLightRooms)
const targetObjectRooms = new THREE.Object3D();
targetObjectRooms.position.set(0, -7, -10)

spotLightRooms.target = targetObjectRooms;







///////////////////////////////////Space INVADER///////////////////////////////////////////////////////////////////////////////





//-------- ----------
// CANVAS ELEMENT, TEXTURE
//-------- ----------



const scoreElement = document.getElementById('scoreElement')
const meilleurScore = document.getElementById('meilleurScore')

const c = canvasSI.getContext('2d')

const audioGameOver = new Audio('/spaceInvader/audio/gameOver.mp3')
const audioBonus = new Audio('/spaceInvader/audio/bonus.mp3')
const audioShoot = new Audio('/spaceInvader/audio/shoot.wav')
const audioEnemyShoot = new Audio('/spaceInvader/audio/enemyShoot.wav')
const audioExplode = new Audio('/spaceInvader/audio/explode.wav')
const audioBackground = new Audio('/spaceInvader/audio/backgroundMusic.wav')



class Player {
    constructor() {

        this.velocity = {
            x: 0,
            y: 0
        }
        this.rotation = 0
        this.opacity = 1

        const image = new Image()
        image.src = "/spaceInvader/img/spaceship.png"

        image.onload = () => {
            const scale = 0.30
            this.image = image
            this.width = image.width * scale
            this.height = image.height * scale
            this.position = {
                x: canvasSI.width / 2 - this.width,
                y: canvasSI.height - this.height - 20
            }
        }

    }
    draw() {

        c.save()
        c.globalAlpha = this.opacity
        c.translate(
            player.position.x + player.width / 2,
            player.position.y + player.height / 2
        )
        c.rotate(this.rotation)
        c.translate(
            -player.position.x - player.width / 2,
            -player.position.y - player.height / 2
        )

        c.drawImage(
            this.image,
            this.position.x,
            this.position.y,
            this.width,
            this.height)

        c.restore()
    }
    update() {
        if (this.image) {
            this.draw()
            this.position.x += this.velocity.x
        }
    }
}

class Projectile {
    constructor({
        position,
        velocity,
        radius,
        color
    }) {
        this.color = color
        this.position = position
        this.velocity = velocity
        this.radius = radius
    }

    draw() {
        c.beginPath()
        c.arc(this.position.x,
            this.position.y,
            this.radius,
            0,
            Math.PI * 2)
        c.fillStyle = this.color
        c.fill()
        c.closePath()

    }


    update() {
        this.draw()
        this.position.x += this.velocity.x
        this.position.y += this.velocity.y
    }
}

class InvaderProjectile {
    constructor({
        position,
        velocity,
    }) {
        this.position = position
        this.velocity = velocity
        this.width = 5
        this.height = 10
    }

    draw() {
        c.fillStyle = 'white'
        c.fillRect(this.position.x, this.position.y, this.width, this.height)

    }


    update() {
        this.draw()
        this.position.x += this.velocity.x
        this.position.y += this.velocity.y
    }
}

class Invader {
    constructor({
        position
    }) {

        this.velocity = {
            x: 0,
            y: 0
        }

        const image = new Image()
        image.src = "/spaceInvader/img/invader.png"

        image.onload = () => {
            const scale = 1
            this.image = image
            this.width = image.width * scale
            this.height = image.height * scale
            this.position = {
                x: position.x,
                y: position.y
            }
        }



    }

    draw() {


        c.drawImage(
            this.image,
            this.position.x,
            this.position.y,
            this.width,
            this.height)

    }
    update({
        velocity
    }) {
        if (this.image) {
            this.draw()
            this.position.x += velocity.x
            this.position.y += velocity.y
        }
    }

    shoot(invaderProjectiles) {
        invaderProjectiles.push(new InvaderProjectile({
            position: {
                x: this.position.x + this.width / 2,
                y: this.position.y + this.height
            },
            velocity: {
                x: 0,
                y: 5
            }
        }))

    }
}

class Grid {
    constructor() {
        this.position = {
            x: 0,
            y: 0
        }
        this.velocity = {
            x: 5,
            y: 0
        }
        this.invaders = []

        const rows = Math.floor(Math.random() * 8 + 2)
        const columns = Math.floor(Math.random() * 10 + 5)

        this.width = columns * 30

        for (let x = 0; x < columns; x++) {
            for (let y = 0; y < rows; y++) {
                this.invaders.push(new Invader({
                    position: {
                        x: x * 30,
                        y: y * 30
                    }
                }))
                console.log(this.invaders)
            }
        }
    }
    update() {
        this.position.x += this.velocity.x
        this.position.y += this.velocity.y
        this.velocity.y = 0

        if (this.position.x + this.width >= canvasSI.width || this.position.x <= 0) {
            this.velocity.x = -this.velocity.x
            this.velocity.y = 30
        }

    }
}

class Particle {
    constructor({
        position,
        velocity,
        radius,
        color,
        fades
    }) {
        this.position = position
        this.velocity = velocity
        this.radius = radius
        this.color = color
        this.opacity = 1
        this.fades = fades
    }

    draw() {
        c.save()
        c.globalAlpha = this.opacity
        c.beginPath()
        c.arc(this.position.x, this.position.y, this.radius, 0,
            Math.PI * 2)
        c.fillStyle = this.color
        c.fill()
        c.closePath()
        c.restore()

    }

    update() {
        this.draw()
        this.position.x += this.velocity.x
        this.position.y += this.velocity.y

        if (this.fades) {
            this.opacity -= 0.003
        }
    }
}

class Bonus {
    constructor({
        position,
        velocity,
    }) {
        this.position = position
        this.velocity = velocity

        const image = new Image()
        image.src = "/spaceInvader/img/bonus.png"

        image.onload = () => {
            const scale = 0.05
            this.image = image
            this.width = image.width * scale
            this.height = image.height * scale
            this.position = {
                x: position.x,
                y: position.y
            }
        }

        this.weapon = []

    }
    draw() {


        c.drawImage(
            this.image,
            this.position.x,
            this.position.y,
            this.width,
            this.height)

    }
    update() {
        if (this.image) {
            this.draw()
            this.position.x += this.velocity.x
            this.position.y += this.velocity.y
        }
    }
}

const player = new Player()
const projectiles = []
const grids = []
const invaderProjectiles = []
const particlesSI = []
const someBonus = []


const key = {
    q: {
        pressed: false
    },
    d: {
        pressed: false
    },
    z: {
        pressed: false
    },
    s: {
        pressed: false
    },
    space: {
        pressed: false
    },
    shoot: {
        pressed: false
    },
    left: {
        pressed: false
    },
    right: {
        pressed: false
    }
}

let frames = 0
let randomInterval = Math.floor((Math.random() * 500) + 500)
let game = {
    over: false,
    active: true
}
game.active = false
let score = 0
let randomWeapon = 2

// Score et Game texte dans le canvas
c.lineWidth = 5 //taille trait texte
c.font = "50pt Arial"
c.style = "white"




function createParticles({
    object,
    color,
    nombre,
    fades
}) {

    for (let i = 0; i < nombre; i++) {
        particlesSI.push(
            new Particle({


                position: {
                    x: object.position.x + object.width / 2,
                    y: object.position.y + object.height / 2
                },
                velocity: {
                    x: (Math.random() - 0.5) * 3,
                    y: (Math.random() - 0.5) * 3
                },
                radius: (Math.random()) * 2,
                color: color || 'white',
                fades: fades
            }))

    }

}
//Particules de fond
for (let i = 0; i < 100; i++) {
    particlesSI.push(
        new Particle({
            position: {
                x: Math.random() * canvasSI.width,
                y: Math.random() * canvasSI.height
            },
            velocity: {
                x: 0,
                y: 0.3
            },
            radius: (Math.random()) * 3,
            color: 'white'
        }))

}



function weaponGolderak() {

    let random = Math.random() * 10
    let random2 = Math.random() * 3
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + player.width / 2,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -20
        },
        radius: random,
        color: 'red'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 20,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -15
        },
        radius: random2,
        color: 'red'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 115,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -15
        },
        radius: random2,
        color: 'red'
    }))
}

function weaponTsunaki() {

    let random = Math.random() * 8
    let random2 = Math.random() * 4
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + player.width / 2,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -20
        },
        radius: random,
        color: 'green'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 30,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -25
        },
        radius: random2,
        color: 'green'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 100,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -25
        },
        radius: random2,
        color: 'green'
    }))
}

function weaponClassic() {

    setTimeout(() => {
        projectiles.push(new Projectile({
            position: {
                x: player.position.x + player.width / 2,
                y: player.position.y
            },
            velocity: {
                x: 0,
                y: -20
            },
            radius: 5,
            color: 'red'
        }))
    }, 0)

}

function weaponTornado() {
    let random = Math.random() * 20
    let random2 = Math.random() * 5
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + player.width / 2,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -50
        },
        radius: random,
        color: 'red'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 20,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -50
        },
        radius: random2,
        color: 'white'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 115,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -50
        },
        radius: random2,
        color: 'white'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -50
        },
        radius: random2,
        color: 'white'
    }))
    projectiles.push(new Projectile({
        position: {
            x: player.position.x + 135,
            y: player.position.y
        },
        velocity: {
            x: 0,
            y: -50
        },
        radius: random2,
        color: 'white'
    }))
}

/*function animate() {

}

animate()*/

addEventListener('keydown', (e) => {
    if (game.over) return

    switch (e.key) {
        case 'q':
            //console.log('left')
            key.q.pressed = true
            break
        case 'd':
            //console.log('write')
            key.d.pressed = true
            break
        case 'z':
            key.z.pressed = true
            //console.log('up')
            break
        case 's':
            key.s.pressed = true
            //console.log('down')
            break
        case ' ':
            //console.log('space')
            key.space.pressed = true

            switch (randomWeapon) {
                case 0:
                    weaponGolderak()
                    break
                case 1:
                    weaponTsunaki()
                    break
                case 2:
                    weaponClassic()
                    break
                case 3:
                    weaponTornado()
                    break
            }


            console.log(randomWeapon)
            break
    }
})
addEventListener('keyup', (e) => {
    switch (e.key) {
        case 'q':
            //console.log('left')
            key.q.pressed = false
            break
        case 'd':
            //console.log('write')
            player.velocity.x = +5
            key.d.pressed = false
            break
        case 'z':
            //console.log('up')
            break
        case 's':
            //console.log('down')
            break
        case ' ':
            //console.log('space')
            key.space.pressed = false
            break
    }
})

// Control bouton machine / Touch event

let boutonMachineClick = null

window.addEventListener('mousedown', () => {
    if (boutonLeftIntersect != null) {
        key.q.pressed = true
        boutonMachineClick = 1
    } else if (boutonRightIntersect != null) {
        key.d.pressed = true
        boutonMachineClick = 1
    } else if (boutonShootIntersect != null) {
        key.space.pressed = true
        boutonMachineClick = 1
        switch (randomWeapon) {
            case 0:
                weaponGolderak()
                break
            case 1:
                weaponTsunaki()
                break
            case 2:
                weaponClassic()
                break
            case 3:
                weaponTornado()
                break
        }
    }

})
window.addEventListener('mouseup', () => {
    if (boutonLeftIntersect != null) {
        key.q.pressed = false
        boutonMachineClick = null
    } else if (boutonRightIntersect != null) {
        key.d.pressed = false
        boutonMachineClick = null
    } else if (boutonShootIntersect != null) {
        key.space.pressed = false
        boutonMachineClick = null
    }

})
window.addEventListener('touchstart', () => {
    if (boutonLeftIntersect != null) {
        key.q.pressed = true
        boutonMachineClick = 1
    } else if (boutonRightIntersect != null) {
        key.d.pressed = true
        boutonMachineClick = 1
    } else if (boutonShootIntersect != null) {
        key.space.pressed = true
        boutonMachineClick = 1
        switch (randomWeapon) {
            case 0:
                weaponGolderak()
                break
            case 1:
                weaponTsunaki()
                break
            case 2:
                weaponClassic()
                break
            case 3:
                weaponTornado()
                break
        }
    }

})
window.addEventListener('touchend', () => {
    if (boutonLeftIntersect != null) {
        key.q.pressed = false
        boutonMachineClick = null
    } else if (boutonRightIntersect != null) {
        key.d.pressed = false
        boutonMachineClick = null
    } else if (boutonShootIntersect != null) {
        key.space.pressed = false
        boutonMachineClick = null
    }

})



///////////////////////////////////Space INVADER///////////////////////////////////////////////////////////////////////////////


/**
 * Scroll
 */
let scrollY = window.scrollY
window.addEventListener('scroll', () => {
    scrollY = window.scrollY

})

/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event) => {
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5

})


/**
 * Mouse / lampe torche 
 */
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) => {
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = -(event.clientY / sizes.height) * 2 + 1

    spotLight.position.set(event.clientX / sizes.width * 2 - 1, -(event.clientY / sizes.height) * 2 + 1, 3)
    targetObject.position.set(event.clientX / sizes.width * 2 - 1, -(event.clientY / sizes.height) * 2 + 1, 0)

})

/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()

/**
 * Audio
 */

let audio = new Audio()
let zoom = null
let zoomSatelitte = null
let tourne = null
let tourneProject = null
let moveProjectOk = null
let moveRetourProjectOk = null
let zoomAsteroide = null
let zoomSpaceInvader = null
let ufoEventOk = null
let son = null
let wheelAction = null
let zoomTableau = null

function entierAleatoire(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Mouvement de Camera
 */

let scrollTop = null
let scrollLeft = null


// fonctions pour desactiver / reactiver le scroll

function disableScroll() {
    // Get the current page scroll position
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,

        // if any scroll is attempted, set this to the previous value
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
}

function enableScroll() {
    window.onscroll = function () {};
}

const TL = gsap.timeline({
    paused: true
});


/////////////////////////////////////////////////////////////////////////////////////////////////

function planeteClearPosition() {

    tourneProject = 0
    disableScroll()
    gsap.to(camera.position, {
        duration: 2,
        z: 6
    })
    gsap.to(planeteRooms.rotation, {
        duration: 2,
        x: 0,
        y: -0.5

    })
    gsap.to(texteStudio.rotation, {
        duration: 2,
        x: 0,
        y: -0.5

    })
    gsap.to(tableauStudio.rotation, {
        duration: 2,
        x: 0,
        y: -0.5

    })
    gsap.to(spaceInvader.rotation, {
        duration: 2,
        x: 0,
        y: -0.5

    })
    gsap.to(leftButtonSi.rotation, rightButtonSi.rotation, spaceButtonSi.rotation, {
        duration: 2,
        x: 0,
        y: -0.5

    })
    gsap.to(flecheProjects.rotation, {
        duration: 2,
        x: Math.PI / 2 - 0.8,
        y: -0.8,
        z: 0
    })
    gsap.to(flecheProjects.position, {
        duration: 2,
        y: -6.2,
        z: 0.2
    })
    gsap.to(flecheProjects.scale, {
        duration: 2,
        x: 3.5,
        y: 3.5,
        z: 3.5
    })
    gsap.to(flecheProjectMove.position, {
        duration: 2,
        x: -5,
        y: -5.4,
        z: -1
    })
    gsap.to(flecheProjectMoveRetour.position, {
        duration: 2,
        x: 5,
        y: -5.4,
        z: -1
    })
    gsap.to(projectLight.position, {
        duration: 2,
        y: -6,
        z: 1
    })
    gsap.to(projectMoveLight.position, {
        duration: 2,
        x: -7,
        y: -5.5,
        z: 0

    })
    gsap.to(planeteRooms.rotation, {
        duration: 2,
        z: 0,
        y: -0.5

    })
    gsap.to(spaceInvader.rotation, {
        duration: 2,
        z: 0,
        y: -0.5

    })
    gsap.to(texteStudio.rotation, {
        duration: 2,
        z: 0,
        y: -0.5

    })
    gsap.to(leftButtonSi.rotation, rightButtonSi.rotation, spaceButtonSi.rotation, {
        duration: 2,
        z: 0,
        y: -0.5

    })

    gsap.to(flecheProjects.position, {
        duration: 2,
        y: -6.2
    })

    if (tourne === 1) {
        gsap.to(flecheCasino.rotation, {
            duration: 2,
            z: flecheCasino.rotation.z + Math.PI * 2,
            y: flecheCasino.rotation.y + Math.PI * 2,
            z: flecheCasino.rotation.z + Math.PI
        })
        gsap.to(flecheCasino.scale, {
            duration: 2,
            x: 4,
            y: 4,
            z: 4
        })
        gsap.to(flecheCasino.position, {
            duration: 2,
            x: 0
        })
    }

    zoom = 0
    tourne = 0
    heightPos = null
    witdhPos = null
    setTimeout(() => {
        enableScroll()
        zoom = null
        tourne = null
        heightPos = 0
        witdhPos = 0
    }, 3000)


}

// SOLEIL action
window.addEventListener('click', () => {
    if (flecheProjectMoveIntersect === null && loadOk === 1) {
        if (currentIntersect2 && zoom === null) {
            disableScroll()
            tl.to(camera.position, {
                z: -63,
                x: -1,
                Y: 0,
                duration: 3,
                onUpdate: function () {
                    camera.lookAt(-13.5, 0, -70)
                }
            })
            TL.staggerTo(titreSpans, 1, {
                left: -50,
                opacity: 0,
                ease: "power2.out"
            }, 0.3)
            TL.play()
            heightPos = null
            witdhPos = null
            zoom = 0
            setTimeout(() => {
                zoom = 1
                enableScroll()
            }, 3000)



        } else if (currentIntersect2 !== null && zoom == 1) {
            disableScroll()
            tl.to(camera.position, {
                z: 0,
                duration: 2
            })
            tl.to(camera.position, {
                z: 6,
                x: 0,
                y: 0,
                duration: 3,
                onUpdate: function () {
                    camera.lookAt(0, 0, 0)
                }
            })

            TL.staggerTo(titreSpans, 1, {
                left: 0,
                opacity: 100,
                ease: "power2.in"
            }, 0.3)

            // Remet la planete dans le bon sens
            planeteClearPosition()


        }

    }
})
let traitEasterEggsDom = document.querySelector(".traits")
let traitEasterEggsCompteur = 0
let imgTraits = ["/img/traits easter eggs/trait1.svg", "/img/traits easter eggs/trait2.svg", "/img/traits easter eggs/trait3.svg", "/img/traits easter eggs/trait4.svg", "/img/traits easter eggs/trait5.svg", "/img/traits easter eggs/trait6.svg"]
let ufoEggs = false
// ZOOM SUR SPACE INVADER
window.addEventListener('click', () => {
    if (spaceInvaderIntersect !== null && zoomSpaceInvader === null && currentIntersectAsteroidRoom === null && flecheProjectIntersect === null && spaceInvaderIntersect != null && loadOk === 1 && heightPos === 1 && witdhPos === 0) {
        gsap.to(camera.position, {
            duration: 2,
            x: -0.2,
            y: -5.5,
            z: -1.28,
            ease: "sine.inOut",
            onUpdate: function () {
                camera.lookAt(-4, -5.5, -3.4)
            }

        })
        disableScroll()
        // space invader set up
        page.style.overflow = 'hidden'
        heightPos = null
        witdhPos = null
        zoomSpaceInvader = 0
        paralaxIntensity = 0.01

        setTimeout(() => {
            zoomSpaceInvader = 1
            if (audioFondOk === true) {
                audioBackground.play()
            }
            audioFond.pause()
            glitchPass.enabled = false
        }, 2000)
        setTimeout(() => {
            game.active = true
            game.over = false
            score = 0
            player.opacity = 1
            // remet à 0 le tableau d'invaders
        }, 2000)



    } else if (spaceInvaderIntersect !== null && zoomSpaceInvader !== null && loadOk === 1 && boutonRightIntersect === null &&
        boutonLeftIntersect === null && boutonShootIntersect === null) {
        gsap.to(camera.position, {
            duration: 2,
            x: 0,
            y: -5,
            z: 6,
            ease: "sine.inOut",
            onUpdate: function () {
                camera.lookAt(0, -5, 0)
            }

        })
        if (audioFondOk === true) {
            audioFond.play()
        }
        game.active = false
        audioBackground.pause();
        audioBackground.currentTime = 0;
        heightPos = null
        witdhPos = null
        zoomSpaceInvader = 0

        // Play the ufo event if ufoEventOk = true
        if (ufoEventOk === 1) {
            if (ufoEggs === false) {
                switch (traitEasterEggsCompteur) {
                    case 0:
                        traitEasterEggsCompteur++
                        traitEasterEggsDom.setAttribute("src", imgTraits[traitEasterEggsCompteur])
                        ufoEggs = true
                        break;
                    case 1:
                        traitEasterEggsCompteur++
                        traitEasterEggsDom.setAttribute("src", imgTraits[traitEasterEggsCompteur])
                        ufoEggs = true
                        break;
                    case 2:
                        traitEasterEggsCompteur++
                        traitEasterEggsDom.setAttribute("src", imgTraits[traitEasterEggsCompteur])
                        ufoEggs = true
                        break;
                    case 3:
                        traitEasterEggsCompteur++
                        traitEasterEggsDom.setAttribute("src", imgTraits[traitEasterEggsCompteur])
                        ufoEggs = true
                        break;
                    case 4:
                        traitEasterEggsCompteur++
                        traitEasterEggsDom.setAttribute("src", imgTraits[traitEasterEggsCompteur])
                        ufoEggs = true
                        break;
                    default:
                        ufoEggs = true
                        break;
                }

            }
            let ufoSound = new Audio("/audio/ufo.mp3")
            if (audioFondOk === true) {
                ufoSound.play()

            }
            gsap.to(flecheCasino.position, {
                duration: 2,
                z: -5,
                ease: "sine.inOut",
            })
            sofaAll.animations.forEach((clip) => {
                mixer9.clipAction(clip).play();
            });
            ufoAll.animations.forEach((clip) => {
                mixer8.clipAction(clip).play();
            });
            ufoEventOk = 0
            setTimeout(() => {
                gsap.to(flecheCasino.position, {
                    duration: 1,
                    z: -3,
                    ease: "sine.inOut",
                })
            }, 10000)
            setTimeout(() => {
                sofaAll.animations.forEach((clip) => {
                    mixer9.clipAction(clip).stop();
                });
                ufoAll.animations.forEach((clip) => {
                    mixer8.clipAction(clip).stop();
                });
                ufoSound.stop()
            }, 16000)
        }

        // Glitch Pass moin récurent
        setInterval(() => {
            if (glitchPass.enabled === false) {
                setTimeout(() => {
                    glitchPass.enabled = true
                }, 5000)
            } else if (glitchPass.enabled === true) {
                glitchPass.enabled = false
            }

        }, 10000)
        setTimeout(() => {
            zoomSpaceInvader = null
            enableScroll()
            page.style.overflow = ''
            paralaxIntensity = 0.3
            heightPos = 1
            witdhPos = 0
        }, 2000)
    }
})

// ZOOM PLANETE ROOMS
window.addEventListener('click', () => {
    if (currentIntersectRoom != null && zoomAsteroide === null && spaceInvaderIntersect === null && zoomSpaceInvader === null && currentIntersectAsteroidRoom == null && flecheProjectIntersect === null && loadOk === 1 && heightPos === 1) {
        gsap.to(camera.position, {
            duration: 2,
            z: 3,
        })
        // space invader set up
        paralaxIntensity = 0.1
        zoomAsteroide = 0
        setTimeout(() => {
            zoomAsteroide = 1
        }, 2000)


    } else if (zoomSpaceInvader === null && zoomTableau === null && spaceInvaderIntersect === null && tableauStudioIntersect === null && zoomAsteroide === 1 && currentIntersectRoom != null && zoomAsteroide === 1 && loadOk === 1 && currentIntersectAsteroidRoom == null && flecheProjectIntersect === null && heightPos === 1) {
        gsap.to(camera.position, {
            duration: 2,
            z: 6
        })
        zoomAsteroide = 0
        setTimeout(() => {
            zoomAsteroide = null
            paralaxIntensity = 0.3
        }, 2000)
    }
})

// ZOOM Tableau Easter Eegs
window.addEventListener('click', () => {
    if (tableauStudioIntersect != null && zoomTableau === null && spaceInvaderIntersect === null && zoomSpaceInvader === null && currentIntersectAsteroidRoom === null && flecheProjectIntersect === null && loadOk === 1 && heightPos === 1) {
        gsap.to(camera.position, {
            duration: 2,
            z: -1.86,
            x: 0.5,
            y: -5.15,
            ease: "sine.inOut",
            onUpdate: function () {
                camera.lookAt(4, -5.5, -7)
            }
        })
        // set up
        paralaxIntensity = 0.01
        zoomAsteroide = 0
        zoomTableau = 1
        setTimeout(() => {
            zoomAsteroide = 1
        }, 2000)


    } else if (zoomAsteroide === 1 && zoomTableau === 1 && zoomSpaceInvader === null && spaceInvaderIntersect === null && zoomAsteroide === 1 && currentIntersectRoom != null && zoomAsteroide === 1 && loadOk === 1 && currentIntersectAsteroidRoom == null && flecheProjectIntersect === null && heightPos === 1) {
        gsap.to(camera.position, {
            duration: 2,
            z: 6,
            x: 0,
            y: -5,
            ease: "sine.inOut",
            onUpdate: function () {
                camera.lookAt(0, -5, 0)
            }
        })
        zoomAsteroide = 0
        zoomTableau = 0
        setTimeout(() => {
            zoomAsteroide = null
            zoomTableau = null
            paralaxIntensity = 0.3
        }, 2000)
    }
})

//ZOOM CV
window.addEventListener('click', () => {
    if (currentIntersectRoom != null && zoomAsteroide === null && spaceInvaderIntersect === null && zoomSpaceInvader === null && currentIntersectAsteroidRoom == null && flecheProjectIntersect === null && loadOk === 1 && loadOk === 1 && witdhPos === -1 && heightPos === 2) {
        gsap.to(camera.position, {
            duration: 2,
            z: -0.4,
            y: -5.4,
            x: -0.2
        })
        gsap.to(camera.rotation, {
            duration: 2,
            z: 0.2
        })
        // space invader set up
        paralaxIntensity = 0.1
        zoomAsteroide = 0
        setTimeout(() => {
            zoomAsteroide = 1
        }, 2000)


    } else if (zoomSpaceInvader === null && spaceInvaderIntersect === null && zoomAsteroide === 1 && currentIntersectRoom != null && zoomAsteroide === 1 && loadOk === 1 && currentIntersectAsteroidRoom == null && flecheProjectIntersect === null && witdhPos === -1 && heightPos === 2) {
        zoomAsteroide = 0
        gsap.to(camera.position, {
            duration: 2,
            z: 3,
            x: 0
        })
        gsap.to(camera.rotation, {
            duration: 2,
            z: 0
        })
        setTimeout(() => {
            zoomAsteroide = null
            paralaxIntensity = 0.3
        }, 2000)
    }
})

// rotation asteroid room

window.addEventListener('click', () => {
    if (currentIntersectAsteroidRoom != null && tourne === null && zoomAsteroide === null && loadOk === 1 && heightPos === 1 && witdhPos === 0) {
        gsap.to(planeteRooms.rotation, {
            duration: 2,
            z: planeteRooms.rotation.z + Math.PI,
            y: planeteRooms.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(spaceInvader.rotation, {
            duration: 2,
            z: spaceInvader.rotation.z + Math.PI,
            y: spaceInvader.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(texteStudio.rotation, {
            duration: 2,
            z: planeteRooms.rotation.z + Math.PI,
            y: planeteRooms.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(tableauStudio.rotation, {
            duration: 2,
            z: tableauStudio.rotation.z + Math.PI,
            y: tableauStudio.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(sofa.rotation, {
            duration: 2,
            z: sofa.rotation.z + Math.PI,
            y: sofa.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(leftButtonSi.rotation, {
            duration: 2,
            z: leftButtonSi.rotation.z + Math.PI,
            y: leftButtonSi.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(rightButtonSi.rotation, {
            duration: 2,
            z: rightButtonSi.rotation.z + Math.PI,
            y: rightButtonSi.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 2,
            z: spaceButtonSi.rotation.z + Math.PI,
            y: spaceButtonSi.rotation.y + Math.PI / 2.5,
            ease: "power2.out"
        })
        gsap.to(flecheCasino.rotation, {
            duration: 2,
            z: flecheCasino.rotation.z + Math.PI * 2,
            y: flecheCasino.rotation.y + Math.PI * 2,
            z: flecheCasino.rotation.z + Math.PI,
            ease: "power2.out"
        })
        gsap.to(flecheCasino.scale, {
            duration: 2,
            x: 2.5,
            y: 2.5,
            z: 2.5
        })
        gsap.to(flecheProjects.position, {
            duration: 4,
            y: -30
        })
        gsap.to(flecheCasino.position, {
            duration: 2,
            x: 0.7
        })
        tourne = 0
        witdhPos = null
        disableScroll()
        setTimeout(() => {
            tourne = 1
            witdhPos = 1
            heightPos = 1
            enableScroll()
        }, 2000)


    } else if (currentIntersectAsteroidRoom !== null && tourne == 1 && zoomAsteroide === null && loadOk === 1 && heightPos === 1 && witdhPos === 1) {
        gsap.to(planeteRooms.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(spaceInvader.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(tableauStudio.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(sofa.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(texteStudio.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(leftButtonSi.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(rightButtonSi.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 2,
            z: 0,
            y: -0.5

        })
        gsap.to(flecheCasino.rotation, {
            duration: 2,
            z: flecheCasino.rotation.z + Math.PI * 2,
            y: flecheCasino.rotation.y + Math.PI * 2,
            z: flecheCasino.rotation.z + Math.PI
        })
        gsap.to(flecheCasino.scale, {
            duration: 2,
            x: 4,
            y: 4,
            z: 4
        })
        gsap.to(flecheProjects.position, {
            duration: 2,
            y: -6.2
        })
        gsap.to(flecheCasino.position, {
            duration: 2,
            x: 0
        })
        tourne = 0
        witdhPos = null
        disableScroll()
        setTimeout(() => {
            tourne = null
            witdhPos = 0
            heightPos = 1
            enableScroll()
        }, 2000)
    }
})

// rotation Projects

window.addEventListener('click', () => {
    if (flecheProjectIntersect != null && tourneProject === null && loadOk === 1 && heightPos === 1 && witdhPos === 0) {
        tourneProject = 0
        disableScroll()
        gsap.to(planeteRooms.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(texteStudio.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(tableauStudio.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(sofa.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(spaceInvader.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(leftButtonSi.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(rightButtonSi.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 2,
            x: -Math.PI / 2 + 0.20
        })
        gsap.to(camera.position, {
            duration: 2,
            z: 3
        })
        gsap.to(flecheProjects.rotation, {
            duration: 2,
            x: Math.PI + 0.8

        })
        gsap.to(flecheProjects.position, {
            duration: 2,
            y: -4.5,
            z: -2
        })
        gsap.to(flecheProjects.scale, {
            duration: 2,
            x: 2.5,
            y: 2.5,
            z: 2.5
        })
        gsap.to(flecheCasino.position, {
            duration: 2,
            y: 20
        })
        gsap.to(flecheProjectMove.position, {
            duration: 2,
            x: -0.5,
            y: -5.4,
            z: -1
        })
        gsap.to(projectLight.position, {
            duration: 2,
            y: -4.5,
            z: -1

        })
        gsap.to(projectMoveLight.position, {
            duration: 2,
            x: -0.5,
            y: -5.5,
            z: -0.5

        })
        heightPos = null
        setTimeout(() => {
            witdhPos = 0
            heightPos = 2
            tourneProject = 1
            enableScroll()
        }, 2000)


    } else if (flecheProjectIntersect != null && tourneProject == 1 && loadOk === 1 && heightPos === 2) {
        tourneProject = 0

        disableScroll()
        gsap.to(camera.position, {
            duration: 2,
            z: 6
        })
        gsap.to(planeteRooms.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(texteStudio.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(spaceInvader.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(tableauStudio.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(sofa.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(leftButtonSi.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(rightButtonSi.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 2,
            x: 0,
            y: -0.5

        })
        gsap.to(flecheProjects.rotation, {
            duration: 2,
            x: Math.PI / 2 - 0.8,
            y: -0.8,
            z: 0
        })
        gsap.to(flecheProjects.position, {
            duration: 2,
            y: -6.2,
            z: 0.2
        })
        gsap.to(flecheProjects.scale, {
            duration: 2,
            x: 3.5,
            y: 3.5,
            z: 3.5
        })
        gsap.to(flecheProjectMove.position, {
            duration: 2,
            x: -5,
            y: -5.4,
            z: -1
        })
        gsap.to(flecheProjectMoveRetour.position, {
            duration: 2,
            x: 5,
            y: -5.4,
            z: -1
        })
        gsap.to(projectLight.position, {
            duration: 2,
            y: -6,
            z: 1
        })
        gsap.to(projectMoveLight.position, {
            duration: 2,
            x: -7,
            y: -5.5,
            z: 0

        })
        gsap.to(flecheCasino.position, {
            duration: 2,
            y: -4,

        })
        heightPos = null
        witdhPos = null
        setTimeout(() => {
            witdhPos = 0
            heightPos = 1
            tourneProject = null
            enableScroll()
        }, 2000)
    }
})

// Move Project

window.addEventListener('click', () => {
    if (flecheProjectMoveIntersect != null && moveProjectOk === null && loadOk === 1 && witdhPos === 0 && heightPos === 2) {
        gsap.to(planeteRooms.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(spaceInvader.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(texteStudio.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(tableauStudio.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(sofa.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(leftButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(rightButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: 0,
        })
        gsap.to(flecheProjectMoveRetour.position, {
            duration: 1,
            x: 0.7,
            y: -5.4,
            z: -1
        })
        gsap.to(projectMoveRetourLight.position, {
            duration: 1,
            x: 1,
            y: -5.5,
            z: -0.5

        })
        gsap.to(flecheProjectMove.position, {
            duration: 2,
            x: -0.7,
            y: -5.4,
            z: -1
        })


        witdhPos = null
        moveProjectOk = 0
        disableScroll()
        setTimeout(() => {
            moveProjectOk = null
            witdhPos = -1
            heightPos = 2
            enableScroll()
        }, 1000)


    }
    /*else if (flecheProjectMoveIntersect !== null && moveProjectOk == 1) {
           gsap.to(planeteRooms.rotation, {
               duration: 2,
               x: -Math.PI / 2 + 0.20,
               z: -0,
               y: 2,

           })

           moveProjectOk = 0
           setTimeout(() => {
               tourneProject = null
           }, 2000)
           disableScroll()
           moveProjectOk = 0
           setTimeout(() => {
               moveProjectOk = null
               enableScroll()
           }, 2000)
       }*/
})

// Move Retour Project

window.addEventListener('click', () => {
    if (flecheProjectMoveRetourIntersect != null && moveRetourProjectOk === null && loadOk === 1 && witdhPos === -1 && heightPos === 2) {
        gsap.to(planeteRooms.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(texteStudio.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(tableauStudio.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(sofa.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(spaceInvader.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(leftButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(rightButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(spaceButtonSi.rotation, {
            duration: 1,
            x: -Math.PI / 2 + 0.20,
            z: -0,
            y: -0.5,
        })
        gsap.to(flecheProjectMoveRetour.position, {
            duration: 1,
            x: 5,
            y: -5.4,
            z: -1
        })
        gsap.to(projectMoveRetourLight.position, {
            duration: 1,
            x: 5,
            y: -5.5,
            z: -0.5

        })
        gsap.to(flecheProjectMove.position, {
            duration: 2,
            x: -0.5,
            y: -5.4,
            z: -1
        })

        disableScroll()
        setTimeout(() => {
            witdhPos = 0
            moveRetourProjectOk = null
            heightPos = 2
            enableScroll()
        }, 1000)


    }
})

// Station Spatial action
window.addEventListener('click', () => {
    if (satelitteIntersect != null && zoomSatelitte === null && loadOk === 1) {
        gsap.to(camera.position, {
            duration: 3,
            x: 16,
            y: 6.5,
            z: -44,
            onUpdate: function () {
                camera.lookAt(-20, 5, -44)
            }
        })
        TL.staggerTo(titreSpans, 1, {
            left: -50,
            opacity: 0,
            ease: "power2.out"
        }, 0.3)
        TL.play()

        zoomSatelitte = 0
        disableScroll()
        setTimeout(() => {

            zoomSatelitte = 1
        }, 3000)


    } else if (satelitteIntersect !== null && zoomSatelitte == 1) {
        gsap.to(camera.position, {
            onUpdate: function () {
                camera.lookAt(0, 0, 0)
            },
            duration: 2,
            x: 0,
            y: 0,
            z: 6,
            onUpdate: function () {
                camera.lookAt(0, 0, 0)
            }
        })
        zoomSatelitte = 0
        TL.staggerTo(titreSpans, 1, {
            left: 0,
            opacity: 100,
            ease: "power2.in"
        }, 0.3)
        setTimeout(() => {
            enableScroll()
            zoomSatelitte = null
            heightPos = 0
            witdhPos = 0
        }, 3000)
    }
})

// evenement au scroll

window.addEventListener('touchmove', function scroll(event) {
    let scroll = event.deltaY;
    let scrollDown = scroll > 0;
    let scrollUp = scroll < 0;

    if (scrollDown) {
        switch (heightPos) {
            case 0:
                if (camera.position.z === 6 && loadOk === 1 && heightPos === 0) {

                    gsap.to(camera.position, {
                        duration: 3,
                        x: 0,
                        y: -5,
                        z: 6,
                        ease: "sine.inOut"

                    })
                    TL.staggerTo(titreSpans, 1, {
                        left: -50,
                        opacity: 0,
                        ease: "power2.out"
                    }, 0.3)
                    TL.play()
                    heightPos = null
                    setTimeout(() => {
                        wheelAction = 1
                        heightPos = 1
                    }, 2100)

                }
                break;
            case 1:
                if (loadOk === 1 && heightPos === 1 && witdhPos === 0) {
                    tourneProject = 0
                    disableScroll()
                    gsap.to(planeteRooms.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(texteStudio.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(tableauStudio.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(sofa.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(spaceInvader.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(leftButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(rightButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(spaceButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(camera.position, {
                        duration: 2,
                        z: 3
                    })
                    gsap.to(flecheProjects.rotation, {
                        duration: 2,
                        x: Math.PI + 0.8

                    })
                    gsap.to(flecheProjects.position, {
                        duration: 2,
                        y: -4.5,
                        z: -2
                    })
                    gsap.to(flecheProjects.scale, {
                        duration: 2,
                        x: 2.5,
                        y: 2.5,
                        z: 2.5
                    })
                    gsap.to(flecheCasino.position, {
                        duration: 2,
                        y: 20
                    })
                    gsap.to(flecheProjectMove.position, {
                        duration: 2,
                        x: -0.5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(projectLight.position, {
                        duration: 2,
                        y: -4.5,
                        z: -1

                    })
                    gsap.to(projectMoveLight.position, {
                        duration: 2,
                        x: -0.5,
                        y: -5.5,
                        z: -0.5

                    })
                    heightPos = 2
                    setTimeout(() => {
                        tourneProject = 1
                        enableScroll()
                    }, 2000)
                }
                break;
            case 2:
                break;
        }
    } else if (scrollUp) {
        switch (heightPos) {
            case 2:
                if (loadOk === 1 && heightPos === 2 && tourneProject === 1) {
                    tourneProject = 0
                    disableScroll()
                    gsap.to(camera.position, {
                        duration: 2,
                        z: 6
                    })
                    gsap.to(planeteRooms.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(texteStudio.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(tableauStudio.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(sofa.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(spaceInvader.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(leftButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(rightButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(spaceButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(flecheProjects.rotation, {
                        duration: 2,
                        x: Math.PI / 2 - 0.8,
                        y: -0.8,
                        z: 0
                    })
                    gsap.to(flecheProjects.position, {
                        duration: 2,
                        y: -6.2,
                        z: 0.2
                    })
                    gsap.to(flecheProjects.scale, {
                        duration: 2,
                        x: 3.5,
                        y: 3.5,
                        z: 3.5
                    })
                    gsap.to(flecheProjectMove.position, {
                        duration: 2,
                        x: -5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(flecheProjectMoveRetour.position, {
                        duration: 2,
                        x: 5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(projectLight.position, {
                        duration: 2,
                        y: -6,
                        z: 1
                    })
                    gsap.to(projectMoveLight.position, {
                        duration: 2,
                        x: -7,
                        y: -5.5,
                        z: 0

                    })
                    gsap.to(flecheCasino.position, {
                        duration: 2,
                        y: -4,

                    })

                    witdhPos = 0
                    heightPos = null
                    setTimeout(() => {
                        heightPos = 1
                        tourneProject = null
                        enableScroll()
                    }, 2000)
                }
                break;
            case 1:
                if (camera.position.z === 6 && loadOk === 1 && heightPos === 1) {
                    gsap.to(camera.position, {
                        duration: 2,
                        x: 0,
                        y: 0,
                        z: 6,
                        ease: "sine.inOut"

                    })
                    heightPos = null
                    setTimeout(() => {
                        TL.staggerTo(titreSpans, 1, {
                            left: 0,
                            opacity: 100,
                            ease: "power2.in"
                        }, 0.3)
                        TL.play()
                    }, 700)
                    setTimeout(() => {
                        heightPos = 0
                    }, 2100)
                }
                break;
        }
    }
});

let y = 0; //current y pos
let sy = y; //previous y pos
let error = 5; //touch sensitivity, I found between 4 and 7 to be good values. 

function move(e) {
    //get current y pos
    y = e.pageY;

    //ingnore user jitter
    if (Math.abs(y - sy) > error) {
        //find direction of y
        if (y > sy) {
            switch (heightPos) {
                case 0:
                    if (camera.position.z === 6 && loadOk === 1 && heightPos === 0) {

                        gsap.to(camera.position, {
                            duration: 3,
                            x: 0,
                            y: -5,
                            z: 6,
                            ease: "sine.inOut"

                        })
                        TL.staggerTo(titreSpans, 1, {
                            left: -50,
                            opacity: 0,
                            ease: "power2.out"
                        }, 0.3)
                        TL.play()
                        heightPos = null
                        setTimeout(() => {
                            wheelAction = 1
                            heightPos = 1
                        }, 2100)

                    }
                    break;
                case 1:
                    if (loadOk === 1 && heightPos === 1 && witdhPos === 0) {
                        tourneProject = 0
                        disableScroll()
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(camera.position, {
                            duration: 2,
                            z: 3
                        })
                        gsap.to(flecheProjects.rotation, {
                            duration: 2,
                            x: Math.PI + 0.8

                        })
                        gsap.to(flecheProjects.position, {
                            duration: 2,
                            y: -4.5,
                            z: -2
                        })
                        gsap.to(flecheProjects.scale, {
                            duration: 2,
                            x: 2.5,
                            y: 2.5,
                            z: 2.5
                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            y: 20
                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -0.5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectLight.position, {
                            duration: 2,
                            y: -4.5,
                            z: -1

                        })
                        gsap.to(projectMoveLight.position, {
                            duration: 2,
                            x: -0.5,
                            y: -5.5,
                            z: -0.5

                        })
                        heightPos = 2
                        setTimeout(() => {
                            tourneProject = 1
                            enableScroll()
                        }, 2000)
                    }
                    break;
                case 2:
                    break;
            }
        } else if (y < sy) {
            switch (heightPos) {
                case 2:
                    if (loadOk === 1 && heightPos === 2 && tourneProject === 1) {
                        tourneProject = 0
                        disableScroll()
                        gsap.to(camera.position, {
                            duration: 2,
                            z: 6
                        })
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })

                        gsap.to(flecheProjects.rotation, {
                            duration: 2,
                            x: Math.PI / 2 - 0.8,
                            y: -0.8,
                            z: 0
                        })
                        gsap.to(flecheProjects.position, {
                            duration: 2,
                            y: -6.2,
                            z: 0.2
                        })
                        gsap.to(flecheProjects.scale, {
                            duration: 2,
                            x: 3.5,
                            y: 3.5,
                            z: 3.5
                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(flecheProjectMoveRetour.position, {
                            duration: 2,
                            x: 5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectLight.position, {
                            duration: 2,
                            y: -6,
                            z: 1
                        })
                        gsap.to(projectMoveLight.position, {
                            duration: 2,
                            x: -7,
                            y: -5.5,
                            z: 0

                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            y: -4,

                        })

                        witdhPos = 0
                        heightPos = null
                        setTimeout(() => {
                            heightPos = 1
                            tourneProject = null
                            enableScroll()
                        }, 2000)
                    }
                    break;
                case 1:
                    if (camera.position.z === 6 && loadOk === 1 && heightPos === 1) {
                        gsap.to(camera.position, {
                            duration: 2,
                            x: 0,
                            y: 0,
                            z: 6,
                            ease: "sine.inOut"

                        })
                        heightPos = null
                        setTimeout(() => {
                            TL.staggerTo(titreSpans, 1, {
                                left: 0,
                                opacity: 100,
                                ease: "power2.in"
                            }, 0.3)
                            TL.play()
                        }, 700)
                        setTimeout(() => {
                            heightPos = 0
                        }, 2100)
                    }
                    break;
            }
        }
        //store current y pos
        sy = y;
    }
}

document.addEventListener('touchmove', move, false);

//fonction Scroll descend monte OUIIII

window.addEventListener("mousewheel", function (event) {
    let scroll = event.deltaY;
    let scrollDown = scroll > 0;
    let scrollUp = scroll < 0;

    if (scrollDown) {
        switch (heightPos) {
            case 0:
                if (camera.position.z === 6 && loadOk === 1 && heightPos === 0) {

                    gsap.to(camera.position, {
                        duration: 3,
                        x: 0,
                        y: -5,
                        z: 6,
                        ease: "sine.inOut"

                    })
                    TL.staggerTo(titreSpans, 1, {
                        left: -50,
                        opacity: 0,
                        ease: "power2.out"
                    }, 0.3)
                    TL.play()
                    heightPos = null
                    setTimeout(() => {
                        wheelAction = 1
                        heightPos = 1
                    }, 2100)

                }
                break;
            case 1:
                if (loadOk === 1 && heightPos === 1 && witdhPos === 0) {
                    tourneProject = 0
                    disableScroll()
                    gsap.to(planeteRooms.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(texteStudio.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(tableauStudio.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(sofa.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(spaceInvader.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(leftButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(rightButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(spaceButtonSi.rotation, {
                        duration: 2,
                        x: -Math.PI / 2 + 0.20
                    })
                    gsap.to(camera.position, {
                        duration: 2,
                        z: 3
                    })
                    gsap.to(flecheProjects.rotation, {
                        duration: 2,
                        x: Math.PI + 0.8

                    })
                    gsap.to(flecheProjects.position, {
                        duration: 2,
                        y: -4.5,
                        z: -2
                    })
                    gsap.to(flecheProjects.scale, {
                        duration: 2,
                        x: 2.5,
                        y: 2.5,
                        z: 2.5
                    })
                    gsap.to(flecheCasino.position, {
                        duration: 2,
                        y: 20
                    })
                    gsap.to(flecheProjectMove.position, {
                        duration: 2,
                        x: -0.5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(projectLight.position, {
                        duration: 2,
                        y: -4.5,
                        z: -1

                    })
                    gsap.to(projectMoveLight.position, {
                        duration: 2,
                        x: -0.5,
                        y: -5.5,
                        z: -0.5

                    })
                    heightPos = 2
                    setTimeout(() => {
                        tourneProject = 1
                        enableScroll()
                    }, 2000)
                }
                break;
                /*    case 2:
                        const basDePage = document.getElementById('submit1')
                        if (loadOk === 1 && heightPos === 2) {
                            window.scrollTo({
                                top: basDePage.offsetTop,
                                behavior: "auto"
                            });
                            heightPos = null
                            setTimeout(() => {
                                heightPos = 3

                            }, 2000)
                        }
                        break;*/
        }
    } else if (scrollUp) {
        switch (heightPos) {
            /*case 3:
                if (loadOk === 1 && heightPos === 3) {
                    window.scrollTo({
                        top: window.offsetTop,
                        behavior: "auto"
                    });

                    heightPos = null
                    setTimeout(() => {
                        heightPos = 2

                    }, 2000)

                }
                break;*/
            case 2:
                if (loadOk === 1 && heightPos === 2 && tourneProject === 1) {

                    tourneProject = 0
                    disableScroll()
                    gsap.to(camera.position, {
                        duration: 2,
                        z: 6
                    })
                    gsap.to(planeteRooms.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(texteStudio.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(tableauStudio.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(sofa.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(spaceInvader.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(leftButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(rightButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(spaceButtonSi.rotation, {
                        duration: 2,
                        x: 0,
                        y: -0.5

                    })
                    gsap.to(flecheProjects.rotation, {
                        duration: 2,
                        x: Math.PI / 2 - 0.8,
                        y: -0.8,
                        z: 0
                    })
                    gsap.to(flecheProjects.position, {
                        duration: 2,
                        y: -6.2,
                        z: 0.2
                    })
                    gsap.to(flecheProjects.scale, {
                        duration: 2,
                        x: 3.5,
                        y: 3.5,
                        z: 3.5
                    })
                    gsap.to(flecheProjectMove.position, {
                        duration: 2,
                        x: -5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(flecheProjectMoveRetour.position, {
                        duration: 2,
                        x: 5,
                        y: -5.4,
                        z: -1
                    })
                    gsap.to(projectLight.position, {
                        duration: 2,
                        y: -6,
                        z: 1
                    })
                    gsap.to(projectMoveLight.position, {
                        duration: 2,
                        x: -7,
                        y: -5.5,
                        z: 0

                    })
                    gsap.to(flecheCasino.position, {
                        duration: 2,
                        y: -4,

                    })

                    witdhPos = 0
                    heightPos = null
                    setTimeout(() => {
                        heightPos = 1
                        tourneProject = null
                        enableScroll()
                    }, 2000)
                }

                break;
            case 1:
                if (camera.position.z === 6 && loadOk === 1 && heightPos === 1) {
                    gsap.to(camera.position, {
                        duration: 2,
                        x: 0,
                        y: 0,
                        z: 6,
                        ease: "sine.inOut"

                    })
                    heightPos = null
                    setTimeout(() => {
                        TL.staggerTo(titreSpans, 1, {
                            left: 0,
                            opacity: 100,
                            ease: "power2.in"
                        }, 0.3)
                        TL.play()
                    }, 700)
                    setTimeout(() => {
                        heightPos = 0
                    }, 2100)
                }
                break;
        }
    }
});


////////////////////// Control fleches ////////////////////

let heightPos = 0
let witdhPos = 0

document.onkeydown = function (e) {
    switch (e.keyCode) {
        case 37: // Left
            switch (witdhPos) {
                case 0:
                    if (moveProjectOk === null && loadOk === 1 && witdhPos === 0 && heightPos === 2) {
                        gsap.to(planeteRooms.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(sofa.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: 0,
                        })
                        gsap.to(flecheProjectMoveRetour.position, {
                            duration: 1,
                            x: 0.7,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectMoveRetourLight.position, {
                            duration: 1,
                            x: 1,
                            y: -5.5,
                            z: -0.5

                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -0.7,
                            y: -5.4,
                            z: -1
                        })

                        witdhPos = -1
                        moveProjectOk = null
                        disableScroll()
                        //     moveProjectOk = 0
                        setTimeout(() => {
                            enableScroll()
                        }, 1000)


                    }

                    break;

                case 1:
                    if (tourne == 1 && loadOk === 1 && witdhPos === 1 && heightPos === 1) {
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            z: 0,
                            y: -0.5

                        })
                        gsap.to(flecheCasino.rotation, {
                            duration: 2,
                            z: flecheCasino.rotation.z + Math.PI * 2,
                            y: flecheCasino.rotation.y + Math.PI * 2,
                            z: flecheCasino.rotation.z + Math.PI
                        })
                        gsap.to(flecheCasino.scale, {
                            duration: 2,
                            x: 4,
                            y: 4,
                            z: 4
                        })
                        gsap.to(flecheProjects.position, {
                            duration: 2,
                            y: -6.2
                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            x: 0
                        })
                        tourne = 0
                        witdhPos = null
                        disableScroll()
                        setTimeout(() => {
                            witdhPos = 0
                            tourne = null
                            enableScroll()
                        }, 2000)
                    }
                    break;

            }

            break;
        case 38: // Up
            switch (heightPos) {
                case 2:
                    if (loadOk === 1 && heightPos === 2 && tourneProject === 1) {
                        tourneProject = 0
                        disableScroll()
                        gsap.to(camera.position, {
                            duration: 2,
                            z: 6
                        })
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            x: 0,
                            y: -0.5

                        })
                        gsap.to(flecheProjects.rotation, {
                            duration: 2,
                            x: Math.PI / 2 - 0.8,
                            y: -0.8,
                            z: 0
                        })
                        gsap.to(flecheProjects.position, {
                            duration: 2,
                            y: -6.2,
                            z: 0.2
                        })
                        gsap.to(flecheProjects.scale, {
                            duration: 2,
                            x: 3.5,
                            y: 3.5,
                            z: 3.5
                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(flecheProjectMoveRetour.position, {
                            duration: 2,
                            x: 5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectLight.position, {
                            duration: 2,
                            y: -6,
                            z: 1
                        })
                        gsap.to(projectMoveLight.position, {
                            duration: 2,
                            x: -7,
                            y: -5.5,
                            z: 0

                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            y: -4,

                        })

                        witdhPos = 0
                        heightPos = null
                        setTimeout(() => {
                            heightPos = 1
                            tourneProject = null
                            enableScroll()
                        }, 2000)
                    }
                    break;
                case 1:
                    if (camera.position.z === 6 && loadOk === 1 && heightPos === 1) {
                        gsap.to(camera.position, {
                            duration: 2,
                            x: 0,
                            y: 0,
                            z: 6,
                            ease: "sine.inOut"

                        })
                        heightPos = null
                        setTimeout(() => {
                            TL.staggerTo(titreSpans, 1, {
                                left: 0,
                                opacity: 100,
                                ease: "power2.in"
                            }, 0.3)
                            TL.play()
                        }, 700)
                        setTimeout(() => {
                            heightPos = 0
                        }, 2100)
                    }
                    break;
            }
            break;
        case 39: //right
            switch (witdhPos) {
                case 0:
                    if (tourne === null && loadOk === 1 && witdhPos === 0 && heightPos === 1) {
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            z: spaceInvader.rotation.z + Math.PI,
                            y: spaceInvader.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            z: planeteRooms.rotation.z + Math.PI,
                            y: planeteRooms.rotation.y + Math.PI / 2.5,
                            ease: "power2.out"
                        })
                        gsap.to(flecheCasino.rotation, {
                            duration: 2,
                            z: flecheCasino.rotation.z + Math.PI * 2,
                            y: flecheCasino.rotation.y + Math.PI * 2,
                            z: flecheCasino.rotation.z + Math.PI,
                            ease: "power2.out"
                        })
                        gsap.to(flecheCasino.scale, {
                            duration: 2,
                            x: 2.5,
                            y: 2.5,
                            z: 2.5
                        })
                        gsap.to(flecheProjects.position, {
                            duration: 4,
                            y: -30
                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            x: 0.7
                        })
                        tourne = 0
                        witdhPos = null
                        disableScroll()
                        setTimeout(() => {
                            witdhPos = 1
                            tourne = 1
                            enableScroll()
                        }, 2000)
                    }
                    break;
                case -1:
                    if (moveRetourProjectOk === null && loadOk === 1 && witdhPos === -1 && heightPos === 2) {
                        gsap.to(planeteRooms.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(sofa.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 1,
                            x: -Math.PI / 2 + 0.20,
                            z: -0,
                            y: -0.5,
                        })
                        gsap.to(flecheProjectMoveRetour.position, {
                            duration: 1,
                            x: 5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectMoveRetourLight.position, {
                            duration: 1,
                            x: 5,
                            y: -5.5,
                            z: -0.5

                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -0.5,
                            y: -5.4,
                            z: -1
                        })

                        witdhPos = 0
                        disableScroll()
                        moveRetourProjectOk = null
                        setTimeout(() => {
                            enableScroll()
                        }, 1000)


                    }
                    break;
            }


            break;
        case 40: // Down
            switch (heightPos) {
                case 0:
                    if (camera.position.z === 6 && loadOk === 1 && heightPos === 0) {

                        gsap.to(camera.position, {
                            duration: 3,
                            x: 0,
                            y: -5,
                            z: 6,
                            ease: "sine.inOut"

                        })
                        TL.staggerTo(titreSpans, 1, {
                            left: -50,
                            opacity: 0,
                            ease: "power2.out"
                        }, 0.3)
                        TL.play()
                        heightPos = null
                        setTimeout(() => {
                            wheelAction = 1
                            heightPos = 1
                        }, 2100)

                    }
                    break;
                case 1:
                    if (loadOk === 1 && heightPos === 1 && witdhPos === 0) {
                        tourneProject = 0
                        disableScroll()
                        gsap.to(planeteRooms.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(texteStudio.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(tableauStudio.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(sofa.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(spaceInvader.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(leftButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(rightButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(spaceButtonSi.rotation, {
                            duration: 2,
                            x: -Math.PI / 2 + 0.20
                        })
                        gsap.to(camera.position, {
                            duration: 2,
                            z: 3
                        })
                        gsap.to(flecheProjects.rotation, {
                            duration: 2,
                            x: Math.PI + 0.8

                        })
                        gsap.to(flecheProjects.position, {
                            duration: 2,
                            y: -4.5,
                            z: -2
                        })
                        gsap.to(flecheProjects.scale, {
                            duration: 2,
                            x: 2.5,
                            y: 2.5,
                            z: 2.5
                        })
                        gsap.to(flecheCasino.position, {
                            duration: 2,
                            y: 20
                        })
                        gsap.to(flecheProjectMove.position, {
                            duration: 2,
                            x: -0.5,
                            y: -5.4,
                            z: -1
                        })
                        gsap.to(projectLight.position, {
                            duration: 2,
                            y: -4.5,
                            z: -1

                        })
                        gsap.to(projectMoveLight.position, {
                            duration: 2,
                            x: -0.5,
                            y: -5.5,
                            z: -0.5

                        })
                        heightPos = 2
                        setTimeout(() => {
                            tourneProject = 1
                            enableScroll()
                        }, 2000)
                    }
                    break;
                case 2:
                    break;
            }
            break;
    }
};



///////////////////////////////////////////////////////////

// Canvas

window.addEventListener('click', () => {
    canvas.style.width
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
let currentIntersect = null
let currentIntersect2 = null
let currentIntersect3 = null
let currentIntersectRoom = null
let currentIntersectAsteroidRoom = null
const tl = gsap.timeline()
let intersects = null
let asteroideTourne = null
let testSun = null
let roomAction = null
let asteroidRoomRotate = null
let satelitteIntersect = null
let satelitteAction = null
let flecheProjectAction = null
let flecheProjectIntersect = null
let flecheProjectMoveAction = null
let flecheProjectMoveIntersect = null
let flecheProjectMoveRetourAction = null
let flecheProjectMoveRetourIntersect = null
let spaceInvaderIntersect = null
let spaceInvaderAction = null
let boutonLeftAction = null
let boutonLeftIntersect = null
let boutonRightAction = null
let boutonRightIntersect = null
let boutonShootAction = null
let boutonShootIntersect = null
let tableauStudioAction = null
let tableauStudioIntersect = null
let paralaxIntensity = 0.3


const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime
    stats.update();



    // Animation objet GLTF


    if (mixer) mixer.update(deltaTime);
    if (mixer2) mixer2.update(deltaTime)
    if (mixer3) mixer3.update(deltaTime)
    if (mixer4) mixer4.update(deltaTime)
    if (mixer5) mixer5.update(deltaTime)
    if (mixer6) mixer6.update(deltaTime)
    if (mixer7) mixer7.update(deltaTime)
    if (mixer8) mixer8.update(deltaTime)
    if (mixer9) mixer9.update(deltaTime)


    // Animate camera
    //controls.update()

    // sun wave

    let now = Date.now() / 600;
    // iterate all vertices
    for (let i = 0; i < count; i++) {
        // indices
        const ix = i * 3;
        const iy = i * 3 + 1;
        const iz = i * 3 + 2;
        // use uvs to calculate wave
        const uX = geometry.attributes.uv.getX(i) * Math.PI * 28;
        const uY = geometry.attributes.uv.getY(i) * Math.PI * 28;
        // calculate current vertex wave height
        const xangle = (uX + now);
        const xsin = Math.sin(xangle) * damping;
        const yangle = (uY + now);
        const ycos = Math.cos(yangle) * damping;
        // set new position
        geometry.attributes.position.setX(i, position_clone[ix] + normals_clone[ix] * (xsin + ycos));
        geometry.attributes.position.setY(i, position_clone[iy] + normals_clone[iy] * (xsin + ycos));
        geometry.attributes.position.setZ(i, position_clone[iz] + normals_clone[iz] * (xsin + ycos));
    }
    geometry.computeVertexNormals();
    geometry.attributes.position.needsUpdate = true;


    //scroll en synchro avec la camera
    /*if (zoomSatelitte == null && zoom == null) {
        camera.position.y = -scrollY / sizes.height * objectsDistance
    }*/

    const parallaxX = cursor.x * paralaxIntensity
    const parallaxY = -cursor.y * paralaxIntensity
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 3 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 3 * deltaTime

    // Animate Meshes

    if (earth, moon, jupiter, mars, mercure, neptune, saturne, sun, uranus, venus, asteroide1, asteroide2, asteroides3, asteroides4, asteroides5, asteroides6, asteroides7, asteroides8) {
        earth.rotation.x = elapsedTime * 0.005
        moon.rotation.x = elapsedTime * 0.005
        jupiter.rotation.x = elapsedTime * 0.005
        mars.rotation.x = elapsedTime * 0.005
        mercure.rotation.x = elapsedTime * 0.005
        neptune.rotation.x = elapsedTime * 0.005
        saturne.rotation.x = elapsedTime * 0.005
        uranus.rotation.x = elapsedTime * 0.005
        venus.rotation.x = elapsedTime * 0.005
        asteroide1.rotation.x = elapsedTime * 0.001
        asteroide2.rotation.x = elapsedTime * 0.001
        asteroides3.rotation.x = elapsedTime * 0.001
        asteroides4.rotation.x = elapsedTime * 0.001
        asteroides5.rotation.x = elapsedTime * 0.001
        asteroides6.rotation.x = elapsedTime * 0.001
        asteroides7.rotation.x = elapsedTime * 0.001
        asteroides8.rotation.x = elapsedTime * 0.001
    }

    // Update controls

    // Cast a ray
    raycaster.setFromCamera(mouse, camera)

    if (solarSystem, asteroides, planeteRooms, theSun, tableauStudioGroup, rooms, satelittes, spaceInvader, flechesProjectsGroupe, flecheProjectMoveGroup, flecheProjectMoveRetourGroup) {
        const objectsToTest = [solarSystem]
        const objectsToTest2 = [asteroides]
        intersects = raycaster.intersectObjects(objectsToTest)
        asteroideTourne = raycaster.intersectObjects(objectsToTest2)
        testSun = raycaster.intersectObject(theSun)
        roomAction = raycaster.intersectObject(rooms)
        asteroidRoomRotate = raycaster.intersectObject(flechesRotates)
        satelitteAction = raycaster.intersectObject(satelittes)
        flecheProjectAction = raycaster.intersectObject(flechesProjectsGroupe)
        flecheProjectMoveAction = raycaster.intersectObject(flecheProjectMoveGroup)
        flecheProjectMoveRetourAction = raycaster.intersectObject(flecheProjectMoveRetourGroup)
        spaceInvaderAction = raycaster.intersectObject(spaceInvaderGroup)
        boutonLeftAction = raycaster.intersectObject(leftButtonGroup)
        boutonRightAction = raycaster.intersectObject(rightButtonGroup)
        boutonShootAction = raycaster.intersectObject(spaceButtonGroup)
        tableauStudioAction = raycaster.intersectObject(tableauStudioGroup)

    }


    // Parametres constant

    theSun.material.color.set('#B1CDD6')
    textSunMaterial.color.set('#ffffff')
    skyLight1.color.set("white")
    skyLight2.color.set("white")
    skyLight3.color.set("white")
    skyLight4.color.set("white")
    skyLight5.color.set("white")
    skyLight6.color.set("white")
    skyLight7.color.set("white")
    skyLight8.color.set("white")
    skyLight9.color.set("white")
    skyLight10.color.set("#EBE1FF")


    if (testSun.length) {
        if (currentIntersect2 === null && loadOk) {
            console.log('mouse enter')
            let entier = entierAleatoire(1, 6)
            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/FX' + entier + '.wav')

            if (audioFondOk === true) {
                audio.play()
            }
            particlesMaterial.color.set("red")


            glitchPass.enabled = false
            currentIntersect2 = testSun[0]

            damping = 0.1

            // test psyché
            /* gsap.to(currentIntersect2.object.scale, {
                 duration: 30,
                 z: 25,
                 x: 20,
                 y: 5
             })*/

        }

    } else {
        if (currentIntersect2) {
            console.log('mouse leave')
            skyLight1.color.set("white")
            skyLight2.color.set("white")
            skyLight3.color.set("white")
            skyLight4.color.set("white")
            skyLight5.color.set("white")
            skyLight6.color.set("white")
            skyLight7.color.set("white")
            skyLight8.color.set("white")
            skyLight9.color.set("white")
            skyLight10.color.set("#EBE1FF")
            damping = 0.03
            particlesMaterial.color.set("white")
            theSun.material.color.set('white')
        }

        currentIntersect2 = null
    }

    // Raycaster HackerRoom

    if (roomAction.length) {
        if (currentIntersectRoom === null) {
            console.log('mouse enter')
            currentIntersectRoom = roomAction[0]


        }

    } else {
        if (currentIntersectRoom) {
            console.log('mouse leave')

        }

        currentIntersectRoom = null
    }

    // Raycaster tableau Studio
    if (tableauStudioAction.length) {
        if (tableauStudioIntersect === null) {
            console.log('mouse enter')
            tableauStudioIntersect = tableauStudioAction[0]
            actionTableauStudio.play();


        }

    } else {
        if (tableauStudioIntersect) {
            console.log('mouse leave')
            setTimeout(() => {
                actionTableauStudio.stop()
            }, 1000)

        }

        tableauStudioIntersect = null
    }

    // Raycaster SpaceInvader

    if (spaceInvaderAction.length && loadOk) {
        if (spaceInvaderIntersect === null) {
            console.log('mouse enter')
            spaceInvaderIntersect = spaceInvaderAction[0]
            projectLight.color.set("white")

            if (zoomSpaceInvader === null) {
                spotLightRooms.color.set("red")
                projectLight.intensity = 10
                actionSpaceInvader.play();
                actionSpaceInvaderScreen.play()
                gsap.to(boutons.position, {
                    duration: 2,
                    y: 2

                })

            }


        }

    } else {
        if (spaceInvaderIntersect) {
            console.log('mouse leave')
            setTimeout(() => {
                actionSpaceInvader.stop();
                actionSpaceInvaderScreen.stop()
            }, 1000)


            projectLight.intensity = 8
            spotLightRooms.color.set("blue")

        }

        spaceInvaderIntersect = null
    }

    // Raycaster SpaceInvader Bouton left

    if (boutonLeftAction.length) {
        if (boutonLeftIntersect === null) {
            console.log('mouse enter')
            boutonLeftIntersect = boutonLeftAction[0]




        }

    } else {
        if (boutonLeftIntersect) {
            console.log('mouse leave')


        }

        boutonLeftIntersect = null
    }

    // Raycaster SpaceInvader Bouton right

    if (boutonRightAction.length) {
        if (boutonRightIntersect === null) {
            console.log('mouse enter')
            boutonRightIntersect = boutonRightAction[0]




        }

    } else {
        if (boutonRightIntersect) {
            console.log('mouse leave')


        }

        boutonRightIntersect = null
    }

    // Raycaster SpaceInvader Bouton space

    if (boutonShootAction.length) {
        if (boutonShootIntersect === null) {
            console.log('mouse enter')
            boutonShootIntersect = boutonShootAction[0]


        }

    } else {
        if (boutonShootIntersect) {
            console.log('mouse leave')


        }

        boutonShootIntersect = null
    }


    // Raycaster Station spatiale

    if (satelitteAction.length) {
        if (satelitteIntersect === null) {
            console.log('mouse enter')
            satelitteIntersect = satelitteAction[0]
            skyLight9.color.set("blue")

        }

    } else {
        if (satelitteIntersect) {
            console.log('mouse leave')
            skyLight9.color.set("white")

        }

        satelitteIntersect = null
    }

    // Raycaster fleche

    if (asteroidRoomRotate.length) {
        if (currentIntersectAsteroidRoom === null && loadOk) {
            console.log('mouse enter')
            let entier = entierAleatoire(1, 6)
            currentIntersectAsteroidRoom = asteroidRoomRotate[0]
            casinoLight1.color.set("white")
            casinoLight1.intensity = 3
            //spotLightRooms.color.set("red")

            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/FX' + entier + '.wav')

            if (audioFondOk === true) {
                audio.play()
            }
        }

    } else {
        if (currentIntersectAsteroidRoom) {

            console.log('mouse leave')
            casinoLight1.color.set("red")
            casinoLight1.intensity = 1
        }

        currentIntersectAsteroidRoom = null
    }

    // Raycaster fleche Projects

    if (flecheProjectAction.length) {
        if (flecheProjectIntersect === null && loadOk) {
            console.log('mouse enter')
            let entier = entierAleatoire(1, 6)
            flecheProjectIntersect = flecheProjectAction[0]
            projectLight.color.set("white")
            projectLight.intensity = 10
            //spotLightRooms.color.set("red")

            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/FX' + entier + '.wav')

            if (audioFondOk === true) {
                audio.play()
            }
        }

    } else {
        if (flecheProjectIntersect) {

            console.log('mouse leave')
            projectLight.color.set("white")
            //spotLightRooms.color.set("blue")
            projectLight.intensity = 8
        }

        flecheProjectIntersect = null
    }

    // Raycaster fleche Projects Move

    if (flecheProjectMoveAction.length) {
        if (flecheProjectMoveIntersect === null && loadOk) {
            console.log('mouse enter')
            let entier = entierAleatoire(1, 6)
            flecheProjectMoveIntersect = flecheProjectMoveAction[0]
            projectMoveLight.color.set("white")
            projectMoveLight.intensity = 2
            //spotLightRooms.color.set("red")

            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/FX' + entier + '.wav')

            if (audioFondOk === true) {
                audio.play()
            }
        }

    } else {
        if (flecheProjectMoveIntersect) {

            console.log('mouse leave')
            projectMoveLight.color.set("white")
            //spotLightRooms.color.set("blue")
            projectMoveLight.intensity = 0.1
        }

        flecheProjectMoveIntersect = null
    }

    // Raycaster fleche Projects Move Retour

    if (flecheProjectMoveRetourAction.length) {
        if (flecheProjectMoveRetourIntersect === null && loadOk) {
            console.log('mouse enter')
            let entier = entierAleatoire(1, 6)
            flecheProjectMoveRetourIntersect = flecheProjectMoveRetourAction[0]
            projectMoveRetourLight.color.set("white")
            projectMoveRetourLight.intensity = 2
            //spotLightRooms.color.set("red")

            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/FX' + entier + '.wav')

            if (audioFondOk === true) {
                audio.play()
            }
        }

    } else {
        if (flecheProjectMoveRetourIntersect) {

            console.log('mouse leave')
            projectMoveRetourLight.color.set("white")
            //spotLightRooms.color.set("blue")
            projectMoveRetourLight.intensity = 0.1
        }

        flecheProjectMoveRetourIntersect = null
    }


    if (intersects.length) {
        if (currentIntersect === null && loadOk) {
            let entier = entierAleatoire(1, 10)
            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/' + entier + '.wav')
            if (audioFondOk === true) {
                audio.play()
            }
            glitchPass.enabled = false
        }

        currentIntersect = intersects[0]
    } else {
        if (currentIntersect) {

        }

        currentIntersect = null
    }

    if (asteroideTourne.length) {
        if (currentIntersect3 === null && loadOk) {
            let entier = entierAleatoire(1, 10)
            let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/B' + entier + '.wav')
            if (audioFondOk === true) {
                audio.play()
            }
            glitchPass.enabled = false
            currentIntersect3 = asteroideTourne[0]
        }

    } else {
        if (currentIntersect3) {

        }

        currentIntersect3 = null
    }

    for (const intersect of asteroideTourne) {
        //intersect.object.material.color.set('#ffffff')
        gsap.to(intersect.object.rotation, {
            duration: 30,
            z: intersect.object.rotation.z + Math.PI * 2,
            x: intersect.object.position.x + Math.PI * 2
        })
    }

    for (const intersect of testSun) {
        skyLight1.visible = true
        skyLight1.color.set("red")
        skyLight2.color.set("red")
        skyLight3.color.set("red")
        skyLight4.color.set("red")
        skyLight5.color.set("red")
        skyLight6.color.set("red")
        skyLight7.color.set("red")
        skyLight8.color.set("red")
        skyLight9.color.set("red")
        skyLight10.color.set("red")
        if (zoom == 1 || zoom == 0) {
            theSun.material.color.set('#623232')

        } else {
            theSun.material.color.set('#623232')
        }

    }

    window.addEventListener('load', () => {
        setTimeout(() => {
            cameraGroup.position.y += (cameraGroup.position.y + 300000) * 1 * deltaTime
            loadCamOk = true
        }, 2000)

    })



    // Render
    //renderer.render(scene, camera)
    effectComposer.render()

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)


    ///////////////////////   SPACE INVADER LOGIQUE ////////////////////////////////////////////////////


    if (!game.active) return

    //requestAnimationFrame(tick)
    c.fillStyle = '#00237B'
    c.fillRect(0, 0, canvasSI.width, canvasSI.height)
    c.fillStyle = "#ff0000"
    c.fillText("q / d / space", 600, 100)

    player.update()


    //Particules bug à résoudre (LAG)

    particlesSI.forEach((particle, i) => {

        if (particle.position.y - particle.radius >= canvasSI.height) {
            particle.position.x = Math.random() * canvasSI.width
            particle.position.y = -particle.radius
        }


        particle.update()

    })

    //invaders hit player
    invaderProjectiles.forEach((invaderProjectile, index) => {
        if (invaderProjectile.position.y + invaderProjectile.height >=
            canvasSI.height) {

            invaderProjectiles.splice(index, 1)


        } else invaderProjectile.update()

        if (game.over === true) {
            c.fillStyle = "#ffffff"
            c.fillText("Game Over", 600, 800)
        }
        if (invaderProjectile.position.y + invaderProjectile.height >= player.position.y &&
            invaderProjectile.position.x + invaderProjectile.width >= player.position.x &&
            invaderProjectile.position.x <= player.position.x + player.width) {


            invaderProjectiles.splice(index, 1)
            player.opacity = 0
            game.over = true

            setTimeout(() => {
                game.active = false

                c.fillText("Play again ?", 600, 800)
            }, 5000)
            //gameOver.innerText = 'GAME OVER'
            if (audioFondOk === true) {
                audioGameOver.play()
            }

            createParticles({
                object: player,
                color: 'white',
                nombre: 20,
                fades: true
            })
        }
    })

    projectiles.forEach((projectile, index) => {
        if (game.over === true) {

            setTimeout(() => {

                projectile.splice(index, 1)


            }, 0)

        }
        if (projectile.position.y + projectile.radius <= 0) {

            projectiles.splice(index, 1)


        } else {
            projectile.update()
        }
    })

    someBonus.forEach((bonus, i) => {
        bonus.update()

        if (bonus.position.y + bonus.height >= player.position.y &&
            bonus.position.x + bonus.width >= player.position.x &&
            bonus.position.x <= bonus.position.x + player.width) {

            randomWeapon = Math.floor(Math.random() * 4)
            someBonus.splice(i, 1)
            createParticles({
                object: player,
                color: 'yellow',
                nombre: 30,
                fades: true
            })
            if (audioFondOk === true) {
                audioBonus.play()
            }




        } else {
            /*  setTimeout(() => {
                  someBonus.splice(i, 1)
              }, 0)*/
        }

    })

    // Texte score canvas
    c.fillText(score, 100, 100)
    c.fillStyle = "#0000ff"

    grids.forEach((grid, gridIndex) => {
        grid.update()


        // Spawn Projectile
        if (frames % 100 === 0 && grid.invaders.length > 0) {
            grid.invaders[Math.floor(Math.random() * grid.invaders.length)].shoot(invaderProjectiles)
        }

        grid.invaders.forEach((invader, i) => {
            if (grid.invaders.length > 0) {
                if (game.over === true) {
                    console.log(grids)

                    setTimeout(() => {
                        grid.invaders.splice(i, 1)
                        //projectiles.splice(j, 1)


                    }, 0)

                }
            }

            invader.update({
                velocity: grid.velocity
            })

            //projectiles hit enemy
            projectiles.forEach((projectile, j) => {


                if (projectile.position.y - projectile.radius <=
                    invader.position.y + invader.height &&
                    projectile.position.x + projectile.radius >=
                    invader.position.x && projectile.position.x -
                    projectile.radius <= invader.position.x + invader.width &&
                    projectile.position.y + projectile.radius >=
                    invader.position.y) {



                    const invaderFound = grid.invaders.find(
                        (invader2) => invader2 === invader)

                    const projectileFound = projectiles.find(
                        (projectile2) => projectile2 ===
                        projectile)

                    //Remove invader & projectile
                    if (invaderFound && projectileFound) {
                        score += 100
                        if (score >= 100) {
                            ufoEventOk = 1
                        }



                        /*createParticles({
                            object: invader,
                            color: 'white',
                            nombre: 15,
                            fades: true
                        })*/
                        if (audioFondOk === true) {
                            audioExplode.play()
                        }


                        grid.invaders.splice(i, 1)
                        projectiles.splice(j, 1)

                        let randomBonus = Math.floor(Math.random() * 150)

                        if (randomBonus == 1) {
                            someBonus.push(new Bonus({
                                position: {
                                    x: invader.position.x,
                                    y: invader.position.y
                                },
                                velocity: {
                                    x: 0,
                                    y: 1
                                }
                            }))

                        }

                        if (grid.invaders.length > 0) {
                            const firstInvader = grid.invaders[0]
                            const lastInvader = grid.invaders[grid.invaders.length - 1]
                            grid.width = lastInvader.position.x -
                                firstInvader.position.x +
                                lastInvader.width
                            grid.position.x = firstInvader.position.x
                        } else {
                            grids.splice(gridIndex, 1)
                        }

                    }


                }

            })

        })
    })

    if (key.q.pressed && player.position.x >= 0) {
        player.velocity.x = -15
        player.rotation = -0.15
    } else if (key.d.pressed && player.position.x + player.width <= canvasSI.width) {
        player.velocity.x = 15
        player.rotation = +0.15
    } else {
        player.velocity.x = 0
        player.rotation = 0
    }

    if (frames % randomInterval === 0) {
        grids.push(new Grid())
        randomInterval = Math.floor((Math.random() * 800) + 250)
        console.log(randomInterval)
    }
    texture.needsUpdate = true;


    frames++

}

/*setInterval(() => {
    let entier = entierAleatoire(1, 2)
    let audio = new Audio('/audio/BRUITAGE MON SUPER SITE/AMBIENT' + entier + '.wav')
    audio.play()
}, 15000)*/


tick()

// Test Video

/*const video = document.getElementById('video');
const texture = new THREE.VideoTexture(video);
scene.add(video)*/